!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("@material-ui/core"), require("classnames"), require("@fortawesome/react-fontawesome"), require("@material-ui/core/styles"), require("@fortawesome/pro-light-svg-icons"), require("color"), require("@material-ui/core/styles/colorManipulator"), require("react-router-dom"), require("react-redux"), require("@datenbanker/devcloud-client-lib"), require("@datenbanker/storage")) : "function" == typeof define && define.amd ? define(["react", "@material-ui/core", "classnames", "@fortawesome/react-fontawesome", "@material-ui/core/styles", "@fortawesome/pro-light-svg-icons", "color", "@material-ui/core/styles/colorManipulator", "react-router-dom", "react-redux", "@datenbanker/devcloud-client-lib", "@datenbanker/storage"], t) : "object" == typeof exports ? exports.index = t(require("react"), require("@material-ui/core"), require("classnames"), require("@fortawesome/react-fontawesome"), require("@material-ui/core/styles"), require("@fortawesome/pro-light-svg-icons"), require("color"), require("@material-ui/core/styles/colorManipulator"), require("react-router-dom"), require("react-redux"), require("@datenbanker/devcloud-client-lib"), require("@datenbanker/storage")) : e.index = t(e.react, e["@material-ui/core"], e.classnames, e["@fortawesome/react-fontawesome"], e["@material-ui/core/styles"], e["@fortawesome/pro-light-svg-icons"], e.color, e["@material-ui/core/styles/colorManipulator"], e["react-router-dom"], e["react-redux"], e["@datenbanker/devcloud-client-lib"], e["@datenbanker/storage"]);
}(window, function (e, t, n, r, a, o, i, s, l, c, u, p) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var a = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var a in e) {
        n.d(r, a, function (t) {
          return e[t];
        }.bind(null, a));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 25);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    e.exports = n(21);
  }, function (e, t) {
    e.exports = i;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, n) {
    "use strict";

    e.exports = function () {};
  }, function (e, t) {
    e.exports = l;
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, n) {
    e.exports = n(23)();
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z";
    t.definition = {
      prefix: "fal",
      iconName: "times",
      icon: [320, 512, r, "f00d", a]
    }, t.faTimes = t.definition, t.prefix = "fal", t.iconName = "times", t.width = 320, t.height = 512, t.ligatures = r, t.unicode = "f00d", t.svgPathData = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M160 217.1c0-8.8 7.2-16 16-16h144v-93.9c0-7.1 8.6-10.7 13.6-5.7l141.6 143.1c6.3 6.3 6.3 16.4 0 22.7L333.6 410.4c-5 5-13.6 1.5-13.6-5.7v-93.9H176c-8.8 0-16-7.2-16-16v-77.7m-32 0v77.7c0 26.5 21.5 48 48 48h112v61.9c0 35.5 43 53.5 68.2 28.3l141.7-143c18.8-18.8 18.8-49.2 0-68L356.2 78.9c-25.1-25.1-68.2-7.3-68.2 28.3v61.9H176c-26.5 0-48 21.6-48 48zM0 112v288c0 26.5 21.5 48 48 48h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h132c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12H48C21.5 64 0 85.5 0 112z";
    t.definition = {
      prefix: "fal",
      iconName: "sign-out-alt",
      icon: [512, 512, r, "f2f5", a]
    }, t.faSignOutAlt = t.definition, t.prefix = "fal", t.iconName = "sign-out-alt", t.width = 512, t.height = 512, t.ligatures = r, t.unicode = "f2f5", t.svgPathData = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z";
    t.definition = {
      prefix: "fal",
      iconName: "bars",
      icon: [448, 512, r, "f0c9", a]
    }, t.faBars = t.definition, t.prefix = "fal", t.iconName = "bars", t.width = 448, t.height = 512, t.ligatures = r, t.unicode = "f0c9", t.svgPathData = a;
  }, function (e, t) {
    e.exports = p;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M413.505 91.951L133.49 371.966l-98.995-98.995c-4.686-4.686-12.284-4.686-16.971 0L6.211 284.284c-4.686 4.686-4.686 12.284 0 16.971l118.794 118.794c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.686-4.686-12.284-4.686-16.97 0z";
    t.definition = {
      prefix: "fal",
      iconName: "check",
      icon: [448, 512, r, "f00c", a]
    }, t.faCheck = t.definition, t.prefix = "fal", t.iconName = "check", t.width = 448, t.height = 512, t.ligatures = r, t.unicode = "f00c", t.svgPathData = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M368 64l-33.6-44.8C325.3 7.1 311.1 0 296 0h-80c-15.1 0-29.3 7.1-38.4 19.2L144 64H40c-13.3 0-24 10.7-24 24v2c0 3.3 2.7 6 6 6h20.9l33.2 372.3C78.3 493 99 512 123.9 512h264.2c24.9 0 45.6-19 47.8-43.7L469.1 96H490c3.3 0 6-2.7 6-6v-2c0-13.3-10.7-24-24-24H368zM216 32h80c5 0 9.8 2.4 12.8 6.4L328 64H184l19.2-25.6c3-4 7.8-6.4 12.8-6.4zm188 433.4c-.7 8.3-7.6 14.6-15.9 14.6H123.9c-8.3 0-15.2-6.3-15.9-14.6L75 96h362l-33 369.4z";
    t.definition = {
      prefix: "fal",
      iconName: "trash",
      icon: [512, 512, r, "f1f8", a]
    }, t.faTrash = t.definition, t.prefix = "fal", t.iconName = "trash", t.width = 512, t.height = 512, t.ligatures = r, t.unicode = "f1f8", t.svgPathData = a;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = [],
        a = "M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z";
    t.definition = {
      prefix: "fal",
      iconName: "plus",
      icon: [384, 512, r, "f067", a]
    }, t.faPlus = t.definition, t.prefix = "fal", t.iconName = "plus", t.width = 384, t.height = 512, t.ligatures = r, t.unicode = "f067", t.svgPathData = a;
  }, function (e, t, n) {
    var r = function () {
      return this || "object" == typeof self && self;
    }() || Function("return this")(),
        a = r.regeneratorRuntime && Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime") >= 0,
        o = a && r.regeneratorRuntime;

    if (r.regeneratorRuntime = void 0, e.exports = n(22), a) r.regeneratorRuntime = o;else try {
      delete r.regeneratorRuntime;
    } catch (e) {
      r.regeneratorRuntime = void 0;
    }
  }, function (e, t) {
    !function (t) {
      "use strict";

      var n,
          r = Object.prototype,
          a = r.hasOwnProperty,
          o = "function" == typeof Symbol ? Symbol : {},
          i = o.iterator || "@@iterator",
          s = o.asyncIterator || "@@asyncIterator",
          l = o.toStringTag || "@@toStringTag",
          c = "object" == typeof e,
          u = t.regeneratorRuntime;
      if (u) c && (e.exports = u);else {
        (u = t.regeneratorRuntime = c ? e.exports : {}).wrap = x;
        var p = "suspendedStart",
            d = "suspendedYield",
            h = "executing",
            f = "completed",
            m = {},
            g = {};

        g[i] = function () {
          return this;
        };

        var v = Object.getPrototypeOf,
            y = v && v(v(N([])));
        y && y !== r && a.call(y, i) && (g = y);
        var b = C.prototype = k.prototype = Object.create(g);
        E.prototype = b.constructor = C, C.constructor = E, C[l] = E.displayName = "GeneratorFunction", u.isGeneratorFunction = function (e) {
          var t = "function" == typeof e && e.constructor;
          return !!t && (t === E || "GeneratorFunction" === (t.displayName || t.name));
        }, u.mark = function (e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, C) : (e.__proto__ = C, l in e || (e[l] = "GeneratorFunction")), e.prototype = Object.create(b), e;
        }, u.awrap = function (e) {
          return {
            __await: e
          };
        }, S(P.prototype), P.prototype[s] = function () {
          return this;
        }, u.AsyncIterator = P, u.async = function (e, t, n, r) {
          var a = new P(x(e, t, n, r));
          return u.isGeneratorFunction(t) ? a : a.next().then(function (e) {
            return e.done ? e.value : a.next();
          });
        }, S(b), b[l] = "Generator", b[i] = function () {
          return this;
        }, b.toString = function () {
          return "[object Generator]";
        }, u.keys = function (e) {
          var t = [];

          for (var n in e) {
            t.push(n);
          }

          return t.reverse(), function n() {
            for (; t.length;) {
              var r = t.pop();
              if (r in e) return n.value = r, n.done = !1, n;
            }

            return n.done = !0, n;
          };
        }, u.values = N, T.prototype = {
          constructor: T,
          reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = n, this.done = !1, this.delegate = null, this.method = "next", this.arg = n, this.tryEntries.forEach(L), !e) for (var t in this) {
              "t" === t.charAt(0) && a.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = n);
            }
          },
          stop: function stop() {
            this.done = !0;
            var e = this.tryEntries[0].completion;
            if ("throw" === e.type) throw e.arg;
            return this.rval;
          },
          dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var t = this;

            function r(r, a) {
              return s.type = "throw", s.arg = e, t.next = r, a && (t.method = "next", t.arg = n), !!a;
            }

            for (var o = this.tryEntries.length - 1; o >= 0; --o) {
              var i = this.tryEntries[o],
                  s = i.completion;
              if ("root" === i.tryLoc) return r("end");

              if (i.tryLoc <= this.prev) {
                var l = a.call(i, "catchLoc"),
                    c = a.call(i, "finallyLoc");

                if (l && c) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                } else if (l) {
                  if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                } else {
                  if (!c) throw new Error("try statement without catch or finally");
                  if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                }
              }
            }
          },
          abrupt: function abrupt(e, t) {
            for (var n = this.tryEntries.length - 1; n >= 0; --n) {
              var r = this.tryEntries[n];

              if (r.tryLoc <= this.prev && a.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                var o = r;
                break;
              }
            }

            o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
            var i = o ? o.completion : {};
            return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, m) : this.complete(i);
          },
          complete: function complete(e, t) {
            if ("throw" === e.type) throw e.arg;
            return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), m;
          },
          finish: function finish(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];
              if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), L(n), m;
            }
          },
          catch: function _catch(e) {
            for (var t = this.tryEntries.length - 1; t >= 0; --t) {
              var n = this.tryEntries[t];

              if (n.tryLoc === e) {
                var r = n.completion;

                if ("throw" === r.type) {
                  var a = r.arg;
                  L(n);
                }

                return a;
              }
            }

            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(e, t, r) {
            return this.delegate = {
              iterator: N(e),
              resultName: t,
              nextLoc: r
            }, "next" === this.method && (this.arg = n), m;
          }
        };
      }

      function x(e, t, n, r) {
        var a = t && t.prototype instanceof k ? t : k,
            o = Object.create(a.prototype),
            i = new T(r || []);
        return o._invoke = function (e, t, n) {
          var r = p;
          return function (a, o) {
            if (r === h) throw new Error("Generator is already running");

            if (r === f) {
              if ("throw" === a) throw o;
              return B();
            }

            for (n.method = a, n.arg = o;;) {
              var i = n.delegate;

              if (i) {
                var s = F(i, n);

                if (s) {
                  if (s === m) continue;
                  return s;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === p) throw r = f, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = h;
              var l = w(e, t, n);

              if ("normal" === l.type) {
                if (r = n.done ? f : d, l.arg === m) continue;
                return {
                  value: l.arg,
                  done: n.done
                };
              }

              "throw" === l.type && (r = f, n.method = "throw", n.arg = l.arg);
            }
          };
        }(e, n, i), o;
      }

      function w(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }

      function k() {}

      function E() {}

      function C() {}

      function S(e) {
        ["next", "throw", "return"].forEach(function (t) {
          e[t] = function (e) {
            return this._invoke(t, e);
          };
        });
      }

      function P(e) {
        var t;

        this._invoke = function (n, r) {
          function o() {
            return new Promise(function (t, o) {
              !function t(n, r, o, i) {
                var s = w(e[n], e, r);

                if ("throw" !== s.type) {
                  var l = s.arg,
                      c = l.value;
                  return c && "object" == typeof c && a.call(c, "__await") ? Promise.resolve(c.__await).then(function (e) {
                    t("next", e, o, i);
                  }, function (e) {
                    t("throw", e, o, i);
                  }) : Promise.resolve(c).then(function (e) {
                    l.value = e, o(l);
                  }, function (e) {
                    return t("throw", e, o, i);
                  });
                }

                i(s.arg);
              }(n, r, t, o);
            });
          }

          return t = t ? t.then(o, o) : o();
        };
      }

      function F(e, t) {
        var r = e.iterator[t.method];

        if (r === n) {
          if (t.delegate = null, "throw" === t.method) {
            if (e.iterator.return && (t.method = "return", t.arg = n, F(e, t), "throw" === t.method)) return m;
            t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return m;
        }

        var a = w(r, e.iterator, t.arg);
        if ("throw" === a.type) return t.method = "throw", t.arg = a.arg, t.delegate = null, m;
        var o = a.arg;
        return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = n), t.delegate = null, m) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, m);
      }

      function O(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function L(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function T(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(O, this), this.reset(!0);
      }

      function N(e) {
        if (e) {
          var t = e[i];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;

          if (!isNaN(e.length)) {
            var r = -1,
                o = function t() {
              for (; ++r < e.length;) {
                if (a.call(e, r)) return t.value = e[r], t.done = !1, t;
              }

              return t.value = n, t.done = !0, t;
            };

            return o.next = o;
          }
        }

        return {
          next: B
        };
      }

      function B() {
        return {
          value: n,
          done: !0
        };
      }
    }(function () {
      return this || "object" == typeof self && self;
    }() || Function("return this")());
  }, function (e, t, n) {
    "use strict";

    var r = n(24);

    function a() {}

    e.exports = function () {
      function e(e, t, n, a, o, i) {
        if (i !== r) {
          var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw s.name = "Invariant Violation", s;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = a, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = {};
    n.r(r), n.d(r, "Form", function () {
      return G;
    }), n.d(r, "Text", function () {
      return X;
    }), n.d(r, "Radio", function () {
      return ee;
    }), n.d(r, "Range", function () {
      return tt;
    }), n.d(r, "Date", function () {
      return at;
    }), n.d(r, "MultiSelect", function () {
      return lt;
    }), n.d(r, "Select", function () {
      return pt;
    }), n.d(r, "Time", function () {
      return ht;
    }), n.d(r, "Chips", function () {
      return kt;
    });
    var a = {};
    n.r(a), n.d(a, "Fab", function () {
      return $t;
    }), n.d(a, "Button", function () {
      return Qt;
    }), n.d(a, "DrawerButton", function () {
      return nn;
    }), n.d(a, "Switch", function () {
      return an;
    });
    var o = n(6),
        i = n.n(o);

    function s(e, t, n, r, a, o, i) {
      try {
        var s = e[o](i),
            l = s.value;
      } catch (e) {
        return void n(e);
      }

      s.done ? t(l) : Promise.resolve(l).then(r, a);
    }

    function l(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, a) {
          var o = e.apply(t, n);

          function i(e) {
            s(o, r, a, i, l, "next", e);
          }

          function l(e) {
            s(o, r, a, i, l, "throw", e);
          }

          i(void 0);
        });
      };
    }

    function c(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function u(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function (t) {
          c(e, t, n[t]);
        });
      }

      return e;
    }

    function p(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function d(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function h(e, t, n) {
      return t && d(e.prototype, t), n && d(e, n), e;
    }

    function f(e) {
      return (f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function m(e) {
      return (m = "function" == typeof Symbol && "symbol" === f(Symbol.iterator) ? function (e) {
        return f(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : f(e);
      })(e);
    }

    function g(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function v(e, t) {
      return !t || "object" !== m(t) && "function" != typeof t ? g(e) : t;
    }

    function y(e) {
      return (y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function b(e, t) {
      return (b = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function x(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && b(e, t);
    }

    var w = n(0),
        k = n.n(w),
        E = n(11),
        C = n(12),
        S = n(17),
        P = new (n.n(S).a)(),
        F = function F(e) {
      return {};
    },
        O = function O(e) {
      var t = function t(_t2, n) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        _t2 && _t2[n] && e({
          type: _t2[n],
          payload: r
        });
      };

      return {
        dispatch: t,
        autoLogin: function autoLogin(e) {
          if (P.get("user:refreshToken")) {
            var n = {
              accessToken: P.get("user:accessToken"),
              idToken: P.get("user:idToken"),
              refreshToken: P.get("user:refreshToken")
            };
            return C.DevCloud.setTokens(n), t(e, "signIn"), !0;
          }

          return !1;
        },
        login: function () {
          var e = l(i.a.mark(function e(n, r, a) {
            var o, s;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return o = new C.Authentication(), e.next = 3, o.login(n, r);

                  case 3:
                    if (!((s = e.sent).accessToken && s.idToken && s.refreshToken)) {
                      e.next = 9;
                      break;
                    }

                    return t(a, "signIn"), e.abrupt("return", !0);

                  case 9:
                    return e.abrupt("return", s);

                  case 10:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, n, r) {
            return e.apply(this, arguments);
          };
        }(),
        challenge: function () {
          var e = l(i.a.mark(function e(n, r, a) {
            var o, s;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return o = new C.Authentication(), e.next = 3, o.challenge(n, r);

                  case 3:
                    return s = e.sent, t(a, "signIn"), e.abrupt("return", s);

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t, n, r) {
            return e.apply(this, arguments);
          };
        }(),
        resetPassword: function () {
          var e = l(i.a.mark(function e(t) {
            var n;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = new C.Authentication(), e.next = 3, n.resetPassword(t);

                  case 3:
                    return e.abrupt("return", e.sent);

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
        resetAccount: function () {
          var e = l(i.a.mark(function e(t) {
            var n;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = new C.Authentication(), e.next = 3, n.resetAccount(t);

                  case 3:
                    return e.abrupt("return", e.sent);

                  case 4:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      };
    },
        L = n(4),
        T = n(1),
        N = n(2),
        B = n.n(N),
        I = n(7),
        A = n.n(I),
        M = {
      palette: {
        primary: "#5c90d2",
        secondary: "#2c689c",
        thirdly: "#2c343f",
        background: "#ececec",
        danger: "#b7433f",
        success: "#559554",
        warning: "#e8db05",
        default: "#b9b9b9",
        fontSubtle: "#686868",
        body: "#ececec",
        grey: "#e0e0e0"
      },
      basic: {
        body: {
          margin: "0px",
          padding: "0px",
          fontSize: "16px"
        },
        html: {
          margin: "0px",
          padding: "0px"
        }
      },
      components: {}
    },
        j = new (function () {
      function e() {
        p(this, e), this.config = u({}, M);
      }

      return h(e, [{
        key: "init",
        value: function value() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
          e && (this.config = e);
          var t = this.config.basic.body;
          Object.keys(t).forEach(function (e) {
            document.body.style[e] = t[e];
          }), document.body.style.backgroundColor = this.config.palette.background;
        }
      }, {
        key: "getConfig",
        value: function value() {
          return this.config;
        }
      }, {
        key: "getStyle",
        value: function value(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = this.getComponentsStyleOverride(),
              r = this.config.palette;
          return n ? n({
            palette: r
          }) : t({
            palette: r
          });
        }
      }, {
        key: "getComponentsStyleOverride",
        value: function value(e) {
          var t = this.config.components;

          try {
            switch (e) {
              case "Block":
                return e.Block;

              case "Layouter":
                return t.Layouter;

              case "Layout/Admin":
                return t.Layout.Admin;

              case "Layout/EmptyPage":
                return t.Layout.EmptyPage;

              case "Form":
                return t.Form.index;

              case "Form/Fields/Date":
                return t.Form.Fields.Date;

              case "Form/Fields/MultiSelect":
                return t.Form.Fields.MultiSelect;

              case "Form/Fields/Radio":
                return t.Form.Fields.Radio;

              case "Form/Fields/Range":
                return t.Form.Fields.Range;

              case "Form/Fields/Select":
                return t.Form.Fields.Select;

              case "Form/Fields/Text":
                return t.Form.Fields.Text;

              case "Form/Fields/Time":
                return t.Form.Fields.Time;

              case "History":
                return t.History;

              case "Browser":
                return t.Browser;

              case "Pagination":
                return t.Pagination;

              case "Sorting":
                return t.Sorting;

              case "SubAppBar":
                return t.SubAppBar;

              case "Buttons/Fab":
                return t.Buttons.Fab;

              case "Buttons/Button":
                return t.Buttons.Button;

              case "Buttons/DrawerButton":
                return t.Buttons.DrawerButton;

              default:
                return;
            }
          } catch (e) {
            return;
          }
        }
      }, {
        key: "convert",
        value: function value(e) {
          var t = this.config,
              n = t.palette,
              r = t.darken;

          switch (e) {
            case "material-ui":
              var a = {
                shadows: Array(25).fill("none"),
                palette: {},
                typography: {
                  useNextVariants: !0
                }
              };

              for (var o in n) {
                a.palette[o] = {
                  main: n[o],
                  dark: A()(n.primary).darken(r).hex()
                };
              }

              return Object(L.createMuiTheme)(a);

            default:
              console.log("conversion type for theme not defined");
          }
        }
      }]), e;
    }())(),
        R = function R(e) {
      return function (t) {
        return {
          block: {
            padding: "16px",
            backgroundColor: "#fff"
          },
          head: {
            margin: "-16px -16px 16px -16px",
            padding: "16px 16px 10px 16px"
          },
          primary: {
            backgroundColor: e.palette.primary,
            color: "#fff"
          }
        };
      };
    },
        D = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.label,
              r = e.children,
              a = e.primary,
              o = e.style,
              i = e.className;
          return k.a.createElement("div", {
            className: t.block + " " + i,
            style: o
          }, k.a.createElement("div", {
            className: B()([!!n && t.head, !(!n || !a) && t.primary])
          }, n && k.a.createElement(T.Typography, {
            variant: "h6",
            className: B()([!(!n || !a) && t.primary])
          }, n)), r);
        }
      }]), t;
    }(),
        H = Object(L.withStyles)(j.getStyle("Block", R))(D),
        _ = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props.textAlign;
          return k.a.createElement("div", {
            style: {
              display: "table",
              height: "100%",
              width: "100%",
              padding: "0px",
              margin: "0px"
            }
          }, k.a.createElement("div", {
            style: {
              display: "table-cell",
              verticalAlign: "middle",
              width: "100%",
              padding: "0px",
              margin: "0px",
              textAlign: e || "left"
            }
          }, this.props.children));
        }
      }]), t;
    }(),
        z = function z(e) {
      return function (e) {
        return {
          overlay: {
            position: "absolute",
            display: "block",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 100,
            backgroundColor: "rgba(255, 255, 255, 0.8)"
          }
        };
      };
    },
        W = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          pending: n.props.pending || !1
        }, n.togglePending = n.togglePending.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "togglePending",
        value: function value(e) {
          this.setState(u({}, this.state, {
            pending: e || !this.state.pending
          }));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.label,
              n = e.children,
              r = e.actions,
              a = e.classes,
              o = e.pendingContent,
              i = this.state.pending,
              s = {
            togglePending: this.togglePending
          };
          return k.a.createElement("form", {
            style: {
              position: "relative"
            }
          }, (i || o) && k.a.createElement("div", {
            className: a.overlay
          }, k.a.createElement(_, {
            textAlign: "center"
          }, k.a.createElement(T.CircularProgress, {
            size: 25
          }))), t && k.a.createElement(T.Typography, {
            variant: "body2",
            gutterBottom: !0
          }, k.a.createElement("span", {
            className: "primary"
          }, t)), k.a.createElement(T.Grid, {
            container: !0,
            spacing: 8
          }, o && k.a.Children.map(this.props.children, function (e) {
            return k.a.cloneElement(e);
          }), !o && n), k.a.createElement("div", {
            style: {
              paddingTop: "15px"
            }
          }, r && r(s)));
        }
      }]), t;
    }(),
        G = Object(L.withStyles)(j.getStyle("Form", z))(W),
        q = n(3),
        V = n(5),
        U = 500,
        Y = 1e3,
        K = n(8),
        Z = function Z(e) {
      return function (t) {
        return {
          labelError: {
            color: e.palette.danger + " !important"
          },
          labelReadOnly: {
            color: e.palette.default.dark + " !important",
            fontWeight: "100 !important",
            background: "none",
            "&:focus": {
              background: "none"
            }
          },
          formControl: {
            width: "100%"
          },
          input: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.secondary + " !important"
            }
          },
          inputSuccess: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            }
          },
          inputError: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            }
          },
          inputReadonly: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          danger: {
            color: e.palette.danger
          },
          success: {
            color: e.palette.success
          },
          default: {
            color: e.palette.default
          },
          defaultLabel: {
            color: "inherit"
          },
          fullFieldRoot: {
            padding: "0px",
            "&:hover": {
              borderRadius: t.shape.borderRadius,
              backgroundColor: Object(K.fade)("#e0e0e0", .5)
            },
            "&:hover:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          fullFieldLabel: {
            zIndex: 2,
            margin: "3px 10px 8px"
          },
          fullFieldLabelShrink: {
            margin: "0px"
          },
          fullFieldInput: {
            color: "inherit",
            width: "100%",
            borderRadius: t.shape.borderRadius,
            padding: "9px 10px 8px",
            backgroundColor: Object(K.fade)("#e0e0e0", .5),
            "&:hover": {
              backgroundColor: Object(K.fade)("#e0e0e0", .5)
            }
          },
          fullFieldReadOnly: {
            padding: "9px 0px 8px"
          },
          multiLineReadOnly: {
            padding: "0px"
          },
          helpBlock: {
            margin: "2px 0px 0px 0px"
          }
        };
      };
    },
        $ = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).formatNumber = function (e) {
          if (e = "string" != typeof e ? "" : e, arguments.length > 1 && void 0 !== arguments[1] && arguments[1]) return e.split(",").join(".");

          switch (document.documentElement.lang) {
            case "de":
              return e.split(".").join(",");

            default:
              return e.split(",").join(".");
          }
        }, n.state = {
          success: !1,
          pending: !1,
          addFloatKomma: !1,
          value: n.props.value
        }, n.handleChange = n.handleChange.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handleChange",
        value: function value(e) {
          var t = this,
              n = this.props.type,
              r = this.formatNumber(e.target.value, !0),
              a = "number" === n ? parseFloat(r) : e.target.value;
          this.setState({
            value: a,
            success: !1,
            pending: !!this.props.instant,
            addFloatKomma: "number" === n && !r.startsWith(".") && r.endsWith(".")
          }), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function e() {
            var n;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.resolve(t.props.onChange(a || null));

                  case 2:
                    n = e.sent, t.setState(u({}, t.state, {
                      success: n,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), U) : this.props.onChange(0 === a ? 0 : a || null);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.xs,
              r = e.sm,
              a = e.md,
              o = e.lg,
              i = e.xl,
              s = e.readOnly,
              l = e.type,
              c = e.strict,
              u = e.rows,
              p = e.label,
              d = e.dontShowLock,
              h = void 0 !== d && d,
              f = e.placeholder,
              m = e.disabled,
              g = e.variant,
              v = e.helpBlock,
              y = this.state.addFloatKomma,
              b = this.props.error && !this.props.readOnly && !this.state.pending,
              x = this.state.success && !this.props.readOnly && !this.state.pending,
              w = {};
          Boolean(f) && (w.shrink = !0);
          var E = this.props.readOnly ? this.props.value || "-" : c ? this.props.value : this.state.value;
          return E = null === E ? "" : E, !s && "number" === l && y && (E = this.formatNumber(E + ".")), E = "number" === l ? this.formatNumber(E + "") : E, k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: n,
            sm: r,
            md: a,
            lg: o,
            xl: i
          }), k.a.createElement(T.FormControl, {
            className: t.formControl
          }, (p || "" === p) && k.a.createElement(T.InputLabel, Object.assign({}, w, {
            className: B()([!!b && t.labelError]),
            classes: {
              root: "fullField" === g && t.fullFieldLabel,
              shrink: "fullField" === g && t.fullFieldLabelShrink
            }
          }), this.props.label, this.state.pending && k.a.createElement(T.CircularProgress, {
            className: t.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), s && !h && k.a.createElement(q.FontAwesomeIcon, {
            className: t.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), b && k.a.createElement(q.FontAwesomeIcon, {
            className: t.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), x && k.a.createElement(q.FontAwesomeIcon, {
            className: t.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement(T.Input, {
            type: l && "number" !== l && !this.props.readOnly ? l : "text",
            multiline: !!u,
            rows: u,
            placeholder: f,
            className: B()(["fullField" !== g ? x ? t.inputSuccess : b ? t.inputError : s ? t.inputReadonly : t.input : s ? t.inputReadonly : t.fullFieldRoot]),
            classes: {
              input: B()(["fullField" === g && !s && t.fullFieldInput, "fullField" === g && s && t.fullFieldReadOnly])
            },
            autoComplete: "password" === l ? "current-password" : "off",
            onChange: this.handleChange,
            value: E,
            readOnly: s,
            disabled: m
          }), b || v && k.a.createElement(T.Typography, {
            className: t.helpBlock,
            variant: "caption"
          }, v)), b && k.a.createElement(T.Typography, {
            className: B()([b ? t.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error));
        }
      }]), t;
    }(),
        X = Object(L.withStyles)(j.getStyle("Form/Fields/Text", Z))($),
        J = function J(e) {
      return function (t) {
        return {
          formControl: {
            width: "100%"
          },
          error: {
            border: "1px solid " + e.palette.danger
          },
          danger: {
            color: e.palette.danger
          },
          success: {
            color: e.palette.success
          },
          default: {
            color: e.palette.default
          },
          defaultLabel: {
            color: "inherit"
          }
        };
      };
    },
        Q = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          value: n.props.value,
          pending: !1,
          success: !1
        }, n.handleChange = n.handleChange.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "handleChange",
        value: function value(e) {
          if (!this.props.readOnly) {
            var t = e.target.value,
                n = u({}, this.state, {
              value: t
            });
            this.setState(n), this.props.onChange(t);
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.xs,
              a = t.sm,
              o = t.md,
              i = t.lg,
              s = t.xl,
              l = t.options,
              c = t.readOnly,
              u = t.disabled,
              p = this.props.error && !c && !this.state.pending,
              d = (this.state.success && !c && this.state.pending, this.props.readOnly ? this.props.value || null : this.state.value);
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: r,
            sm: a,
            md: o,
            lg: i,
            xl: s
          }), k.a.createElement("div", {
            className: "static-form-control"
          }, k.a.createElement(T.FormControl, {
            className: B()([n.formControl])
          }, k.a.createElement(T.RadioGroup, {
            "aria-label": "reset type",
            value: d,
            onChange: this.handleChange
          }, l.map(function (t, r) {
            return k.a.createElement(T.FormControlLabel, {
              key: "radio" + r + t.value,
              value: t.value,
              control: k.a.createElement(T.Radio, {
                className: B()([p ? n.danger : ""]),
                color: "primary",
                disabled: u
              }),
              label: k.a.createElement("div", null, t.label, " ", e.props.readOnly && k.a.createElement(q.FontAwesomeIcon, {
                className: n.default,
                style: {
                  marginLeft: "5px"
                },
                icon: V.faLockAlt
              })),
              labelPlacement: "end"
            });
          }))), p && k.a.createElement(T.Typography, {
            className: B()([p ? n.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error)));
        }
      }]), t;
    }(),
        ee = Object(L.withStyles)(j.getStyle("Form/Fields/Radio", J))(Q),
        te = function te(e) {
      return function (t) {
        return {
          formControl: {
            width: "100%",
            height: "48px"
          },
          label: {
            transformOrigin: "top left",
            transform: "translate(0, 1.5px) scale(0.75)"
          },
          labelError: {
            color: e.palette.danger + " !important"
          },
          labelReadOnly: {
            color: e.palette.default.dark + " !important",
            fontWeight: "100 !important",
            background: "none",
            "&:focus": {
              background: "none"
            }
          },
          rail: {
            position: "absolute",
            width: "100%",
            height: 2,
            marginTop: 16,
            borderRadius: 5,
            backgroundColor: e.palette.primary,
            opacity: .2
          },
          handle: {
            position: "absolute",
            marginLeft: -8,
            marginTop: 10,
            zIndex: 1,
            width: 16,
            height: 16,
            border: 0,
            textAlign: "center",
            cursor: "pointer",
            borderRadius: "50%",
            backgroundColor: e.palette.primary,
            color: "#fff"
          },
          track: {
            position: "absolute",
            height: 2,
            zIndex: 1,
            marginTop: 16,
            backgroundColor: e.palette.primary,
            borderRadius: 5,
            cursor: "pointer"
          },
          linearProgessRail: {
            position: "absolute",
            width: "100%",
            height: 4,
            marginTop: 16,
            backgroundColor: e.palette.primary,
            opacity: .2
          },
          linearProgressTrack: {
            position: "absolute",
            height: 4,
            zIndex: 1,
            marginTop: 16,
            backgroundColor: e.palette.primary,
            cursor: "pointer"
          },
          disabled: {
            backgroundColor: e.palette.default
          },
          button: {
            width: "20px",
            height: "20px"
          },
          buttonStart: {
            marginLeft: "10px"
          },
          buttonEnd: {
            marginLeft: "-10px"
          },
          rangeInputReadOnly: {
            margin: "16px 0px 13px 0px",
            zIndex: "0"
          },
          rangeInput: {
            margin: "16px 0px 13px 0px",
            zIndex: "0"
          },
          danger: {
            color: e.palette.danger
          },
          success: {
            color: e.palette.success
          },
          default: {
            color: e.palette.default
          },
          defaultLabel: {
            color: "inherit"
          }
        };
      };
    };

    function ne(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = [],
            r = !0,
            a = !1,
            o = void 0;

        try {
          for (var i, s = e[Symbol.iterator](); !(r = (i = s.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          a = !0, o = e;
        } finally {
          try {
            r || null == s.return || s.return();
          } finally {
            if (a) throw o;
          }
        }

        return n;
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }();
    }

    function re(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function ae(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function oe(e, t, n) {
      return t && ae(e.prototype, t), n && ae(e, n), e;
    }

    function ie(e) {
      return (ie = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function se(e) {
      return (se = "function" == typeof Symbol && "symbol" === ie(Symbol.iterator) ? function (e) {
        return ie(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : ie(e);
      })(e);
    }

    function le(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function ce(e, t) {
      return !t || "object" !== se(t) && "function" != typeof t ? le(e) : t;
    }

    function ue(e) {
      return (ue = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function pe(e, t) {
      return (pe = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function de(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && pe(e, t);
    }

    function he(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    var fe = n(9),
        me = n.n(fe);
    n(13);

    function ge(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {},
            r = Object.keys(n);
        "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
          return Object.getOwnPropertyDescriptor(n, e).enumerable;
        }))), r.forEach(function (t) {
          he(e, t, n[t]);
        });
      }

      return e;
    }

    var ve = function ve() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      return function () {
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
          n[r] = arguments[r];
        }

        return t.forEach(function (e) {
          return e && e.apply(void 0, n);
        });
      };
    },
        ye = function (e) {
      function t() {
        var e, n;
        re(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return he(le(le(n = ce(this, (e = ue(t)).call.apply(e, [this].concat(a))))), "getRailProps", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = n.props,
              r = t.emitMouse,
              a = t.emitTouch;
          return ge({}, e, {
            onMouseDown: ve(e.onMouseDown, r),
            onTouchStart: ve(e.onTouchStart, a)
          });
        }), n;
      }

      return de(t, w["Component"]), oe(t, [{
        key: "render",
        value: function value() {
          var e = this.getRailProps,
              t = this.props,
              n = t.getEventData,
              r = t.activeHandleID,
              a = (0, t.children)({
            getEventData: n,
            activeHandleID: r,
            getRailProps: e
          });
          return a && k.a.Children.only(a);
        }
      }]), t;
    }();

    ye.propTypes = {};

    var be = ye,
        xe = function (e) {
      function t() {
        return re(this, t), ce(this, ue(t).apply(this, arguments));
      }

      return de(t, w["Component"]), oe(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.children,
              n = e.values,
              r = e.scale,
              a = e.count,
              o = t({
            getEventData: e.getEventData,
            activeHandleID: e.activeHandleID,
            ticks: (n || r.getTicks(a)).map(function (e) {
              return {
                id: "$$-".concat(e),
                value: e,
                percent: r.getValue(e)
              };
            })
          });
          return o && k.a.Children.only(o);
        }
      }]), t;
    }();

    xe.propTypes = {}, xe.defaultProps = {
      count: 10
    };

    var we = xe,
        ke = function (e) {
      function t() {
        var e, n;
        re(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return he(le(le(n = ce(this, (e = ue(t)).call.apply(e, [this].concat(a))))), "getTrackProps", function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = n.props,
              r = t.emitMouse,
              a = t.emitTouch;
          return ge({}, e, {
            onMouseDown: ve(e.onMouseDown, r),
            onTouchStart: ve(e.onTouchStart, a)
          });
        }), n;
      }

      return de(t, w["Component"]), oe(t, [{
        key: "render",
        value: function value() {
          for (var e = this.getTrackProps, t = this.props, n = t.children, r = t.left, a = t.right, o = t.scale, i = t.handles, s = t.getEventData, l = t.activeHandleID, c = o.getDomain(), u = [], p = 0; p < i.length + 1; p++) {
            var d = i[p - 1],
                h = i[p];
            0 === p && !0 === r ? d = {
              id: "$",
              value: c[0],
              percent: 0
            } : p === i.length && !0 === a && (h = {
              id: "$",
              value: c[1],
              percent: 100
            }), d && h && u.push({
              id: "".concat(d.id, "-").concat(h.id),
              source: d,
              target: h
            });
          }

          var f = n({
            getEventData: s,
            activeHandleID: l,
            tracks: u,
            getTrackProps: e
          });
          return f && k.a.Children.only(f);
        }
      }]), t;
    }();

    ke.propTypes = {}, ke.defaultProps = {
      left: !0,
      right: !0
    };

    var Ee = ke,
        Ce = function (e) {
      function t() {
        var e, n;
        re(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return he(le(le(n = ce(this, (e = ue(t)).call.apply(e, [this].concat(a))))), "autofocus", function (e) {
          e.target.focus();
        }), he(le(le(n)), "getHandleProps", function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.props,
              a = r.emitKeyboard,
              o = r.emitMouse,
              i = r.emitTouch;
          return ge({}, t, {
            onKeyDown: ve(t.onKeyDown, function (t) {
              return a(t, e);
            }),
            onMouseDown: ve(t.onMouseDown, n.autofocus, function (t) {
              return o(t, e);
            }),
            onTouchStart: ve(t.onTouchStart, function (t) {
              return i(t, e);
            })
          });
        }), n;
      }

      return de(t, w["Component"]), oe(t, [{
        key: "render",
        value: function value() {
          var e = this.getHandleProps,
              t = this.props,
              n = t.activeHandleID,
              r = (0, t.children)({
            handles: t.handles,
            activeHandleID: n,
            getHandleProps: e
          });
          return r && k.a.Children.only(r);
        }
      }]), t;
    }();

    Ce.propTypes = {};
    var Se = Ce;

    function Pe(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var Fe = "react-compound-slider:";

    function Oe(e) {
      return function (t, n) {
        return t.val > n.val ? e ? -1 : 1 : n.val > t.val ? e ? 1 : -1 : 0;
      };
    }

    function Le(e, t, n, r) {
      var a = e.findIndex(function (e) {
        return e.key === t;
      });

      if (-1 !== a) {
        var o = e[a],
            i = o.key;
        return o.val === n ? e : [].concat(Pe(e.slice(0, a)), [{
          key: i,
          val: n
        }], Pe(e.slice(a + 1))).sort(Oe(r));
      }

      return e;
    }

    function Te(e, t, n) {
      if (!e) return [0, 0];
      var r = e.getBoundingClientRect(),
          a = t ? r.top : r.left,
          o = t ? r.bottom : r.right,
          i = Math.abs(a - o) / n.n / 2;
      return [a - i, o + i];
    }

    function Ne(e, t, n) {
      for (var r, a = (r = "".concat(n).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/)) ? Math.max(0, (r[1] ? r[1].length : 0) - (r[2] ? +r[2] : 0)) : 0, o = +e.toFixed(a), i = +t.toFixed(a), s = [], l = o; l <= i;) {
        if (s.push(l), l = +(l + n).toFixed(a), s.length > 1e6) throw new Error("Slider range is too large. Increase step value.");
      }

      return s;
    }

    function Be(e) {
      var t = e.type,
          n = void 0 === t ? "" : t,
          r = e.touches;
      return !r || r.length > 1 || "touchend" === n.toLowerCase() && r.length > 0;
    }

    function Ie(e, t) {
      return e ? t.touches[0].clientY : t.touches[0].pageX;
    }

    function Ae() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = arguments.length > 2 ? arguments[2] : void 0,
          r = arguments.length > 3 ? arguments[3] : void 0,
          a = 0;
      return {
        handles: e.map(function (e) {
          var t = n.getValue(e);
          return e !== t && (a += 1, me()(!r, "".concat(Fe, " Invalid value encountered. Changing ").concat(e, " to ").concat(t, "."))), t;
        }).map(function (e, t) {
          return {
            key: "$$-".concat(t),
            val: e
          };
        }).sort(Oe(t)),
        changes: a
      };
    }

    var Me = function Me(e, t) {
      return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
    };

    var je,
        Re,
        De = (1 === (je = Me).length && (Re = je, je = function je(e, t) {
      return Me(Re(e), t);
    }), {
      left: function left(e, t, n, r) {
        for (null == n && (n = 0), null == r && (r = e.length); n < r;) {
          var a = n + r >>> 1;
          je(e[a], t) < 0 ? n = a + 1 : r = a;
        }

        return n;
      },
      right: function right(e, t, n, r) {
        for (null == n && (n = 0), null == r && (r = e.length); n < r;) {
          var a = n + r >>> 1;
          je(e[a], t) > 0 ? r = a : n = a + 1;
        }

        return n;
      }
    }),
        He = De.right;

    var _e = Array.prototype,
        ze = (_e.slice, _e.map, Math.sqrt(50)),
        We = Math.sqrt(10),
        Ge = Math.sqrt(2),
        qe = function qe(e, t, n) {
      var r,
          a,
          o,
          i,
          s = -1;
      if (n = +n, (e = +e) === (t = +t) && n > 0) return [e];
      if ((r = t < e) && (a = e, e = t, t = a), 0 === (i = function (e, t, n) {
        var r = (t - e) / Math.max(0, n),
            a = Math.floor(Math.log(r) / Math.LN10),
            o = r / Math.pow(10, a);
        return a >= 0 ? (o >= ze ? 10 : o >= We ? 5 : o >= Ge ? 2 : 1) * Math.pow(10, a) : -Math.pow(10, -a) / (o >= ze ? 10 : o >= We ? 5 : o >= Ge ? 2 : 1);
      }(e, t, n)) || !isFinite(i)) return [];
      if (i > 0) for (e = Math.ceil(e / i), t = Math.floor(t / i), o = new Array(a = Math.ceil(t - e + 1)); ++s < a;) {
        o[s] = (e + s) * i;
      } else for (e = Math.floor(e * i), t = Math.ceil(t * i), o = new Array(a = Math.ceil(e - t + 1)); ++s < a;) {
        o[s] = (e - s) / i;
      }
      return r && o.reverse(), o;
    };

    var Ve = function () {
      function e() {
        re(this, e), this.domain = [0, 1], this.range = [0, 1], this.interpolator = null;
      }

      return oe(e, [{
        key: "createInterpolator",
        value: function value(e, t) {
          var n = e[0],
              r = e[1],
              a = t[0],
              o = t[1];
          return r < n ? (n = this.deinterpolateValue(r, n), a = this.interpolateValue(o, a)) : (n = this.deinterpolateValue(n, r), a = this.interpolateValue(a, o)), function (e) {
            return a(n(e));
          };
        }
      }, {
        key: "interpolateValue",
        value: function value(e, t) {
          return t -= e = +e, function (n) {
            return e + t * n;
          };
        }
      }, {
        key: "deinterpolateValue",
        value: function value(e, t) {
          return (t -= e = +e) ? function (n) {
            return (n - e) / t;
          } : function () {
            return t;
          };
        }
      }, {
        key: "rescale",
        value: function value() {
          return this.interpolator = null, this;
        }
      }, {
        key: "getValue",
        value: function value(e) {
          var t = this.domain,
              n = this.range;
          return (this.interpolator || (this.interpolator = this.createInterpolator(t, n)))(+e);
        }
      }, {
        key: "setDomain",
        value: function value(e) {
          return this.domain = e.map(function (e) {
            return +e;
          }), this.rescale(), this;
        }
      }, {
        key: "getDomain",
        value: function value() {
          return this.domain;
        }
      }, {
        key: "setRange",
        value: function value(e) {
          return this.range = e.map(function (e) {
            return +e;
          }), this;
        }
      }, {
        key: "getTicks",
        value: function value(e) {
          var t = this.domain;
          return qe(t[0], t[t.length - 1], e || 10);
        }
      }]), e;
    }(),
        Ue = function () {
      function e() {
        var t = this;
        re(this, e), he(this, "getValue", function (e) {
          var n = t.range,
              r = t.domain,
              a = t.n;
          return n[He(r, e, 0, a)];
        }), he(this, "setDomain", function (e) {
          return t.x0 = +e[0], t.x1 = +e[1], t.rescale(), t;
        }), he(this, "setRange", function (e) {
          return t.range = e.slice(), t.n = t.range.length - 1, t;
        }), this.x0 = 0, this.x1 = 1, this.domain = [.5], this.range = [0, 1], this.n = 1;
      }

      return oe(e, [{
        key: "rescale",
        value: function value() {
          var e = this.x0,
              t = this.x1,
              n = this.n,
              r = -1;

          for (this.domain = new Array(n); ++r < n;) {
            this.domain[r] = ((r + 1) * t - (r - n) * e) / (n + 1);
          }
        }
      }]), e;
    }(),
        Ye = "undefined" != typeof window && "undefined" != typeof document,
        Ke = function Ke() {},
        Ze = function Ze(e, t, n, r) {
      var a;
      return a = r ? e - t : e + t, r ? Math.max(n[0], a) : Math.min(n[1], a);
    },
        $e = function $e(e, t, n, r) {
      var a;
      return a = r ? e + t : e - t, r ? Math.min(n[1], a) : Math.max(n[0], a);
    },
        Xe = function (e) {
      function t() {
        var e, n;
        re(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return he(le(le(n = ce(this, (e = ue(t)).call.apply(e, [this].concat(a))))), "state", {
          step: null,
          values: null,
          domain: null,
          handles: null,
          reversed: null,
          activeHandleID: null,
          valueToPerc: null,
          valueToStep: null,
          pixelToStep: null
        }), he(le(le(n)), "slider", k.a.createRef()), he(le(le(n)), "onKeyDown", function (e, t) {
          var r = ["ArrowRight", "ArrowUp"],
              a = ["ArrowDown", "ArrowLeft"],
              o = le(le(n)),
              i = o.state.handles,
              s = o.props,
              l = s.step,
              c = s.reversed,
              u = s.vertical,
              p = s.domain,
              d = e.key || e.keyCode;

          if (r.concat(a).includes(d)) {
            if (u) {
              var h = [a, r];
              r = h[0], a = h[1];
            }

            e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
            var f = i.find(function (e) {
              return e.key === t;
            });

            if (f) {
              var m = f.val,
                  g = m;
              r.includes(d) ? g = Ze(m, l, p, c) : a.includes(d) && (g = $e(m, l, p, c));
              var v = i.map(function (e) {
                return e.key === t ? {
                  key: e.key,
                  val: g
                } : e;
              });
              n.submitUpdate(v, !0);
            }
          }
        }), he(le(le(n)), "onMouseDown", function (e, t) {
          n.onStart(e, t, !1);
        }), he(le(le(n)), "onTouchStart", function (e, t) {
          Be(e) || n.onStart(e, t, !0);
        }), he(le(le(n)), "getEventData", function (e, t) {
          var r,
              a = le(le(n)),
              o = a.state,
              i = o.pixelToStep,
              s = o.valueToPerc,
              l = a.props.vertical;
          return {
            value: r = t ? i.getValue(Ie(l, e)) : i.getValue(l ? e.clientY : e.pageX),
            percent: s.getValue(r)
          };
        }), he(le(le(n)), "onMouseMove", function (e) {
          var t = le(le(n)),
              r = t.state,
              a = r.handles,
              o = r.pixelToStep,
              i = r.activeHandleID,
              s = t.props,
              l = s.vertical,
              c = s.reversed,
              u = le(le(n)).slider;
          o.setDomain(Te(u.current, l, o));
          var p = Le(a, i, o.getValue(l ? e.clientY : e.pageX), c);
          n.submitUpdate(p);
        }), he(le(le(n)), "onTouchMove", function (e) {
          var t = le(le(n)),
              r = t.state,
              a = r.handles,
              o = r.pixelToStep,
              i = r.activeHandleID,
              s = t.props,
              l = s.vertical,
              c = s.reversed,
              u = le(le(n)).slider;

          if (!Be(e)) {
            o.setDomain(Te(u.current, l, o));
            var p = Le(a, i, o.getValue(Ie(l, e)), c);
            n.submitUpdate(p);
          }
        }), he(le(le(n)), "onMouseUp", function () {
          var e = le(le(n)),
              t = e.state,
              r = t.handles,
              a = t.activeHandleID,
              o = e.props,
              i = o.onChange,
              s = o.onSlideEnd;
          i(r.map(function (e) {
            return e.val;
          })), s(r.map(function (e) {
            return e.val;
          }), {
            activeHandleID: a
          }), n.setState({
            activeHandleID: null
          }), Ye && (document.removeEventListener("mousemove", n.onMouseMove), document.removeEventListener("mouseup", n.onMouseUp));
        }), he(le(le(n)), "onTouchEnd", function () {
          var e = le(le(n)),
              t = e.state,
              r = t.handles,
              a = t.activeHandleID,
              o = e.props,
              i = o.onChange,
              s = o.onSlideEnd;
          i(r.map(function (e) {
            return e.val;
          })), s(r.map(function (e) {
            return e.val;
          }), {
            activeHandleID: a
          }), n.setState({
            activeHandleID: null
          }), Ye && (document.removeEventListener("touchmove", n.onTouchMove), document.removeEventListener("touchend", n.onTouchEnd));
        }), n;
      }

      return de(t, w["PureComponent"]), oe(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this.state.pixelToStep,
              t = this.props.vertical;
          e.setDomain(Te(this.slider.current, t, e));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.removeListeners();
        }
      }, {
        key: "removeListeners",
        value: function value() {
          Ye && (document.removeEventListener("mousemove", this.onMouseMove), document.removeEventListener("mouseup", this.onMouseUp), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
        }
      }, {
        key: "onStart",
        value: function value(e, t, n) {
          var r = this.state.handles,
              a = this.props.onSlideStart;
          e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault(), r.find(function (e) {
            return e.key === t;
          }) ? (this.setState({
            activeHandleID: t
          }), a(r.map(function (e) {
            return e.val;
          }), {
            activeHandleID: t
          }), n ? this.addTouchEvents() : this.addMouseEvents()) : (this.setState({
            activeHandleID: null
          }), this.handleRailAndTrackClicks(e, n));
        }
      }, {
        key: "handleRailAndTrackClicks",
        value: function value(e, t) {
          var n,
              r = this.state,
              a = r.handles,
              o = r.pixelToStep,
              i = this.props,
              s = i.vertical,
              l = i.reversed,
              c = this.slider;
          o.setDomain(Te(c.current, s, o)), n = t ? o.getValue(Ie(s, e)) : o.getValue(s ? e.clientY : e.pageX);

          for (var u = null, p = 1 / 0, d = 0; d < a.length; d++) {
            var h = a[d],
                f = h.key,
                m = h.val,
                g = Math.abs(m - n);
            g < p && (u = f, p = g);
          }

          var v = Le(a, u, n, l);
          this.submitUpdate(v, !0);
        }
      }, {
        key: "addMouseEvents",
        value: function value() {
          Ye && (document.addEventListener("mousemove", this.onMouseMove), document.addEventListener("mouseup", this.onMouseUp));
        }
      }, {
        key: "addTouchEvents",
        value: function value() {
          Ye && (document.addEventListener("touchmove", this.onTouchMove), document.addEventListener("touchend", this.onTouchEnd));
        }
      }, {
        key: "submitUpdate",
        value: function value(e, t) {
          var n = this.props,
              r = n.mode,
              a = n.step,
              o = n.onUpdate,
              i = n.onChange,
              s = n.reversed,
              l = this.state.valueToStep.getValue;
          this.setState(function (n) {
            var c,
                u = n.handles;
            if ("function" == typeof r) c = r(u, e, a, s, l), me()(Array.isArray(c), "Custom mode function did not return an array.");else switch (r) {
              case 1:
                c = function (e, t) {
                  return t;
                }(0, e);

                break;

              case 2:
                c = function (e, t) {
                  for (var n = 0; n < e.length; n++) {
                    if (e[n].key !== t[n].key) return e;
                    if (t[n + 1] && t[n].val === t[n + 1].val) return e;
                  }

                  return t;
                }(u, e);

                break;

              case 3:
                c = function e(t, n, r, a, o) {
                  for (var i = -1, s = !0, l = 0; l < t.length; l++) {
                    var c = t[l],
                        u = n[l];
                    if (!u || u.key !== c.key) return t;
                    u.val !== c.val && (i = l, s = u.val - c.val > 0);
                  }

                  if (-1 === i) return t;

                  for (var p = s ? r : -r, d = 0; d < n.length; d++) {
                    var h = n[d],
                        f = n[d + 1];

                    if (f && h.val === f.val) {
                      if (d === i) {
                        var m = f.val + p;

                        if (o(m) === m) {
                          var g = e(n, Le(n, f.key, f.val + p, a), r, a, o);
                          return g === n ? t : g;
                        }

                        return t;
                      }

                      var v = h.val + p;

                      if (o(v) === v) {
                        var y = e(n, Le(n, h.key, h.val + p, a), r, a, o);
                        return y === n ? t : y;
                      }

                      return t;
                    }
                  }

                  return n;
                }(u, e, a, s, l);

                break;

              default:
                c = e, me()(!1, "".concat(Fe, " Invalid mode value."));
            }
            return o(c.map(function (e) {
              return e.val;
            })), t && i(c.map(function (e) {
              return e.val;
            })), {
              handles: c
            };
          });
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.state,
              n = t.handles,
              r = t.valueToPerc,
              a = t.activeHandleID,
              o = this.props,
              i = o.className,
              s = o.rootStyle,
              l = o.disabled,
              c = n.map(function (e) {
            var t = e.key,
                n = e.val;
            return {
              id: t,
              value: n,
              percent: r.getValue(n)
            };
          }),
              u = k.a.Children.map(this.props.children, function (t) {
            return t.type.name === be.name || t.type.name === we.name || t.type.name === Ee.name || t.type.name === Se.name ? k.a.cloneElement(t, {
              scale: r,
              handles: c,
              activeHandleID: a,
              getEventData: e.getEventData,
              emitKeyboard: l ? Ke : e.onKeyDown,
              emitMouse: l ? Ke : e.onMouseDown,
              emitTouch: l ? Ke : e.onTouchStart
            }) : t;
          });
          return k.a.createElement("div", {
            style: s || {},
            className: i,
            ref: this.slider
          }, u);
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function value(e, t) {
          var n,
              r,
              a = e.step,
              o = e.values,
              i = e.domain,
              s = e.reversed,
              l = e.onUpdate,
              c = e.onChange,
              u = e.warnOnChanges,
              p = t.valueToPerc,
              d = t.valueToStep,
              h = t.pixelToStep,
              f = {};

          if (p && d && h || (p = new Ve(), d = new Ue(), h = new Ue(), f.valueToPerc = p, f.valueToStep = d, f.pixelToStep = h), null === t.step || null === t.domain || null === t.reversed || a !== t.step || i[0] !== t.domain[0] || i[1] !== t.domain[1] || s !== t.reversed) {
            var m = ne(i, 2),
                g = m[0],
                v = m[1],
                y = Ne(g, v, a);
            d.setRange(y).setDomain([g - a / 2, v + a / 2]), !0 === s ? (p.setDomain([g, v]).setRange([100, 0]), y.reverse()) : p.setDomain([g, v]).setRange([0, 100]), h.setRange(y), me()(v > g, "".concat(Fe, " Max must be greater than min (even if reversed). Max is ").concat(v, ". Min is ").concat(g, "."));
            me()(y.length <= 100001, "".concat(Fe, " Increase step value (set to ").concat(a, " currently). Found ").concat(y.length.toLocaleString(), " values in range. Max is ").concat(100001..toLocaleString(), "."));
            var b = y.length - 1;
            me()(y[s ? b : 0] === g && y[s ? 0 : b] === v, "".concat(Fe, " The range is incorrectly calculated. Check domain (min, max) and step values."));
            var x = Ae(o || t.values, s, d, u),
                w = x.handles;
            (x.changes || void 0 === o || o === t.values) && (l(w.map(function (e) {
              return e.val;
            })), c(w.map(function (e) {
              return e.val;
            }))), f.step = a, f.values = o, f.domain = i, f.handles = w, f.reversed = s;
          } else if (n = o, r = t.values, !(n === r || n.length === r.length && n.reduce(function (e) {
            return function (t, n, r) {
              return t && e[r] === n;
            };
          }(r), !0))) {
            var k = Ae(o, s, d, u),
                E = k.handles;
            k.changes && (l(E.map(function (e) {
              return e.val;
            })), c(E.map(function (e) {
              return e.val;
            }))), f.values = o, f.handles = E;
          }

          return Object.keys(f).length ? f : null;
        }
      }]), t;
    }();

    Xe.propTypes = {}, Xe.defaultProps = {
      mode: 1,
      step: .1,
      domain: [0, 100],
      vertical: !1,
      reversed: !1,
      onChange: Ke,
      onUpdate: Ke,
      onSlideStart: Ke,
      onSlideEnd: Ke,
      disabled: !1,
      warnOnChanges: !1
    };
    var Je = Xe;
    Je.Rail = be, Je.Ticks = we, Je.Tracks = Ee, Je.Handles = Se;

    var Qe = {
      position: "relative",
      width: "100%",
      height: 32
    },
        et = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          value: Array.isArray(n.props.value) ? n.props.value : [n.props.value]
        }, n.handelChange = n.handelChange.bind(g(g(n))), n.ranger = n.ranger.bind(g(g(n))), n.linearProgress = n.linearProgress.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handelChange",
        value: function value(e) {
          var t = this;
          this.props.disabled || (this.setState({
            value: e,
            success: !1,
            pending: !!this.props.instant
          }), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function n() {
            var r;
            return i.a.wrap(function (n) {
              for (;;) {
                switch (n.prev = n.next) {
                  case 0:
                    return n.next = 2, Promise.resolve(t.props.onChange(e));

                  case 2:
                    r = n.sent, t.setState(u({}, t.state, {
                      success: r,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return n.stop();
                }
              }
            }, n, this);
          })), U) : this.props.onChange(e));
        }
      }, {
        key: "ranger",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.step,
              r = e.min,
              a = e.max,
              o = e.readOnly,
              i = e.disabled,
              s = o ? this.props.value : this.state.value;
          return k.a.createElement(Je, {
            rootStyle: Qe,
            domain: [r, a],
            step: n,
            values: s,
            onChange: this.handelChange,
            onUpdate: this.handelChange,
            disabled: i
          }, k.a.createElement("div", {
            className: B()([t.rail, i && t.disabled])
          }), k.a.createElement(Se, null, function (e) {
            var n = e.handles,
                o = e.getHandleProps;
            return k.a.createElement("div", {
              className: "slider-handles"
            }, n.map(function (e, n) {
              var s = e.id,
                  l = e.value,
                  c = e.percent,
                  u = {
                left: "".concat(c, "%")
              };
              return l === r && (u.marginLeft = "0px"), l === a && (u.marginLeft = "-16px"), k.a.createElement("div", Object.assign({
                key: s + "-" + n,
                style: u,
                className: B()([t.handle, i && t.disabled])
              }, o(s)));
            }));
          }), k.a.createElement(Ee, {
            right: !1,
            left: 1 === s.length
          }, function (e) {
            var n = e.tracks,
                r = e.getTrackProps;
            return k.a.createElement("div", null, n.map(function (e, n) {
              var a = e.id,
                  o = e.source,
                  s = e.target;
              return k.a.createElement("div", Object.assign({
                key: "track" + a + "-" + n,
                className: B()([t.track, i && t.disabled]),
                style: {
                  left: "".concat(o.percent, "%"),
                  width: "".concat(s.percent - o.percent, "%")
                }
              }, r()));
            }));
          }));
        }
      }, {
        key: "linearProgress",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.value,
              r = e.min,
              a = e.max,
              o = e.disabled,
              i = {};
          return 1 === n.length ? (i.left = "0%", i.right = 100 - 100 / (a - r) * (n[0] - r) + "%") : (i.left = 100 / (a - r) * (n[0] - r) + "%", i.right = 100 - 100 / (a - r) * (n[n.length - 1] - r) + "%"), k.a.createElement("div", {
            className: t.linearProgressWrapper
          }, k.a.createElement("div", {
            className: B()([t.linearProgessRail, o && t.disabled])
          }), k.a.createElement("div", {
            style: i,
            className: B()([t.linearProgressTrack, o && t.disabled])
          }));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.xs,
              r = e.sm,
              a = e.md,
              o = e.lg,
              i = e.xl,
              s = e.readOnly,
              l = e.dontShowLock,
              c = void 0 !== l && l,
              u = this.props.error && !s && !this.state.pending,
              p = this.state.success && !s && !this.state.pending,
              d = this.ranger,
              h = this.linearProgress;
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: n,
            sm: r,
            md: a,
            lg: o,
            xl: i
          }), k.a.createElement(T.FormControl, {
            className: t.formControl
          }, k.a.createElement(T.InputLabel, {
            className: B()([t.label, !!u && t.labelError])
          }, this.props.label, " -", " ", this.props.readOnly ? this.props.value.join(", ") : this.state.value.join(", "), this.state.pending && k.a.createElement(T.CircularProgress, {
            className: t.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), s && !c && k.a.createElement(q.FontAwesomeIcon, {
            className: t.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), u && k.a.createElement(q.FontAwesomeIcon, {
            className: t.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), p && k.a.createElement(q.FontAwesomeIcon, {
            className: t.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement("div", {
            className: s ? t.rangeInputReadOnly : t.rangeInput
          }, s && k.a.createElement(h, {
            variant: "determinate",
            value: 10 * this.props.value
          }), !s && k.a.createElement(d, null))), u && k.a.createElement(T.Typography, {
            className: B()([u ? t.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error));
        }
      }]), t;
    }(),
        tt = Object(L.withStyles)(j.getStyle("Form/Fields/Range", te))(et),
        nt = function nt(e) {
      return function (t) {
        return {
          label: {
            transformOrigin: "top left",
            transform: "translate(0, 1.5px) scale(0.75)"
          },
          labelSuccess: {
            color: e.palette.success + " !important"
          },
          labelReadOnly: {
            color: e.palette.default.dark + " !important",
            fontWeight: "100 !important",
            background: "none",
            "&:focus": {
              background: "none"
            }
          },
          labelError: {
            color: e.palette.danger + " !important"
          },
          formControl: {
            width: "100%"
          },
          input: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.secondary + " !important"
            }
          },
          inputSuccess: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            }
          },
          inputError: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            }
          },
          inputReadonly: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          danger: {
            color: e.palette.danger
          },
          success: {
            color: e.palette.success
          },
          default: {
            color: e.palette.default
          },
          defaultLabel: {
            color: "inherit"
          },
          fullFieldRoot: {
            padding: "0px",
            "&:hover": {
              borderRadius: t.shape.borderRadius,
              backgroundColor: Object(K.fade)(t.palette.grey.main, .5)
            },
            "&:hover:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          fullFieldLabel: {
            zIndex: 2,
            margin: "0"
          },
          fullFieldInput: {
            color: "inherit",
            width: "100%",
            borderRadius: t.shape.borderRadius,
            padding: "9px 10px 8px",
            backgroundColor: Object(K.fade)(t.palette.grey.main, .5),
            "&:hover": {
              backgroundColor: Object(K.fade)(t.palette.grey.main, .5)
            }
          }
        };
      };
    },
        rt = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          success: !1,
          pending: !1,
          value: n.props.value
        }, n.handleChange = n.handleChange.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handleChange",
        value: function value(e) {
          var t = this,
              n = e.target.value;
          this.setState({
            value: n,
            success: !1,
            pending: !!this.props.instant
          }), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function e() {
            var r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.resolve(t.props.onChange(n || null));

                  case 2:
                    r = e.sent, t.setState(u({}, t.state, {
                      success: r,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), U) : this.props.onChange(n || null);
        }
      }, {
        key: "render",
        value: function value() {
          var e,
              t,
              n,
              r,
              a,
              o = this.props,
              i = o.classes,
              s = o.xs,
              l = o.sm,
              c = o.md,
              u = o.lg,
              p = o.xl,
              d = o.readOnly,
              h = o.disabled,
              f = o.label,
              m = o.dontShowLock,
              g = void 0 !== m && m,
              v = o.variant,
              y = this.props.error && !this.props.readOnly && !this.state.pending,
              b = this.state.success && !this.props.readOnly && !this.state.pending;
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: s,
            sm: l,
            md: c,
            lg: u,
            xl: p
          }), k.a.createElement(T.FormControl, {
            className: i.formControl
          }, (f || "" === f) && k.a.createElement(T.InputLabel, {
            className: B()([i.label, !!y && i.labelError]),
            classes: {
              root: "fullField" === v && i.fullFieldLabel,
              shrink: "fullField" === v && i.fullFieldLabelShrink
            }
          }, this.props.label, this.state.pending && k.a.createElement(T.CircularProgress, {
            className: i.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), d && !g && k.a.createElement(q.FontAwesomeIcon, {
            className: i.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), y && k.a.createElement(q.FontAwesomeIcon, {
            className: i.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), b && k.a.createElement(q.FontAwesomeIcon, {
            className: i.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement(T.Input, {
            type: this.props.readOnly ? "text" : "date",
            className: B()(["fullField" !== v ? b ? i.inputSuccess : y ? i.inputError : d ? i.inputReadonly : i.input : d ? i.inputReadonly : i.fullFieldRoot]),
            classes: {
              input: "fullField" === v && !d && i.fullFieldInput
            },
            onChange: this.handleChange,
            value: this.props.readOnly ? this.props.value ? (e = this.props.value, t = new Date(e), n = t.getFullYear(), r = t.getMonth(), a = t.getDate(), (a < 10 ? "0" : "") + a + "." + (r + 1 < 10 ? "0" : "") + (r + 1) + "." + n) : "-" : this.state.value,
            readOnly: d,
            disabled: h
          })), y && k.a.createElement(T.Typography, {
            className: B()([y ? i.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error));
        }
      }]), t;
    }(),
        at = Object(L.withStyles)(j.getStyle("Form/Fields/Date", nt))(rt),
        ot = function ot(e) {
      return function (t) {
        return {
          labelError: {
            color: e.palette.danger + " !important"
          },
          labelReadOnly: {
            color: e.palette.default.dark + " !important",
            fontWeight: "100 !important",
            background: "none",
            "&:focus": {
              background: "none"
            }
          },
          formControl: {
            width: "100%"
          },
          disabledCursor: {
            cursor: "not-allowed !important"
          },
          input: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.default + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.secondary + " !important"
            }
          },
          inputSuccess: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.success + " !important"
            }
          },
          inputError: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:before": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            },
            "&:after": {
              borderBottom: "1px solid " + e.palette.danger + " !important"
            }
          },
          inputReadonly: {
            width: "100%",
            "&:hover:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:before": {
              borderBottom: "1px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          chip: {
            height: "15px",
            margin: "2px 1px",
            backgroundColor: e.palette.primary,
            color: "#fff"
          },
          danger: {
            color: e.palette.danger
          },
          success: {
            color: e.palette.success
          },
          default: {
            color: e.palette.default
          },
          defaultLabel: {
            color: "inherit"
          },
          placeholder: {
            color: "rgba(0, 0, 0, .54)"
          },
          fullFieldRoot: {
            padding: "0px",
            "&:hover": {
              borderRadius: t.shape.borderRadius,
              backgroundColor: Object(K.fade)(t.palette.grey.main, .5)
            },
            "&:hover:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:before": {
              borderBottom: "0px solid #fff !important"
            },
            "&:after": {
              borderBottom: "0px solid"
            }
          },
          fullFieldLabel: {
            zIndex: 2,
            margin: "3px 10px 8px"
          },
          fullFieldLabelShrink: {
            margin: "0px"
          },
          fullFieldInput: {
            color: "inherit",
            borderRadius: t.shape.borderRadius,
            padding: "9px 10px 8px",
            backgroundColor: Object(K.fade)(t.palette.grey.main, .5)
          },
          fullFieldSelect: {
            "&:focus": {
              borderRadius: t.shape.borderRadius
            },
            "&:hover": {
              backgroundColor: Object(K.fade)(t.palette.grey.main, .5)
            }
          }
        };
      };
    },
        it = {
      PaperProps: {
        style: {
          border: "1px solid #ececec",
          maxHeight: 224,
          width: 250,
          whiteSpace: "normal"
        }
      }
    },
        st = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          success: !1,
          pending: !1,
          value: n.props.value
        }, n.handleChange = n.handleChange.bind(g(g(n))), n.handleClose = n.handleClose.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;

          it.onExiting = function (t) {
            e.handleClose(t);
          };
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handleChange",
        value: function value(e) {
          this.setState(u({}, this.state, {
            value: e.target.value
          }));
        }
      }, {
        key: "handleClose",
        value: function value(e) {
          var t = this,
              n = this.state.value;
          this.setState(u({}, this.state, {
            success: !1,
            pending: !!this.props.instant
          })), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function e() {
            var r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.resolve(t.props.onChange(n || null));

                  case 2:
                    r = e.sent, t.setState(u({}, t.state, {
                      success: r,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), U) : this.props.onChange(n);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.xs,
              a = t.sm,
              o = t.md,
              i = t.lg,
              s = t.xl,
              l = t.readOnly,
              c = t.disabled,
              u = t.label,
              p = t.variant,
              d = this.props.error && !this.props.readOnly && !this.state.pending,
              h = this.state.success && !this.props.readOnly && !this.state.pending;
          return l && !this.props.value.length ? k.a.createElement(X, Object.assign({
            xs: r,
            sm: a,
            md: o,
            lg: i,
            xl: s,
            readOnly: l,
            disabled: c,
            label: u
          }, {
            value: ""
          })) : k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: r,
            sm: a,
            md: o,
            lg: i,
            xl: s
          }), k.a.createElement("div", {
            className: "instant-form-control"
          }, k.a.createElement(T.FormControl, {
            className: n.formControl
          }, k.a.createElement(T.InputLabel, {
            className: B()([h ? n.success : "", d ? n.danger : ""]),
            classes: {
              root: "fullField" === p && n.fullFieldLabel,
              shrink: "fullField" === p && n.fullFieldLabelShrink
            }
          }, this.props.label, this.state.pending && k.a.createElement(T.CircularProgress, {
            className: n.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), l && k.a.createElement(q.FontAwesomeIcon, {
            className: n.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), d && k.a.createElement(q.FontAwesomeIcon, {
            className: n.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), h && k.a.createElement(q.FontAwesomeIcon, {
            className: n.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement(T.Select, {
            style: {
              whiteSpace: "normal"
            },
            classes: {
              selectMenu: B()(["fullField" === p && n.fullFieldSelect, !!c && n.disabledCursor])
            },
            multiple: !0,
            value: l ? this.props.value : this.state.value,
            readOnly: l,
            disabled: c || l,
            onChange: this.handleChange,
            onClose: this.handleClose,
            input: k.a.createElement(T.Input, {
              className: B()(["fullField" !== p ? h ? n.inputSuccess : d ? n.inputError : l ? n.inputReadonly : n.input : l ? n.inputReadonly : n.fullFieldRoot]),
              classes: {
                input: "fullField" === p && !l && n.fullFieldInput
              }
            }),
            renderValue: function renderValue(t) {
              return k.a.createElement("div", null, t.map(function (t) {
                var r = t,
                    a = "object" == typeof e.props.options[0] ? e.props.options.find(function (e) {
                  return e.value === r;
                }).label : t;
                return k.a.createElement(T.Chip, {
                  key: r,
                  label: a,
                  className: n.chip
                });
              }));
            },
            MenuProps: it
          }, this.props.options.map(function (e) {
            var t = "object" == typeof e ? e.label : e,
                n = "object" == typeof e ? e.value : e;
            return k.a.createElement(T.MenuItem, {
              key: n,
              value: n
            }, t);
          }))), d && k.a.createElement(T.Typography, {
            className: B()([d ? n.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error)));
        }
      }]), t;
    }(),
        lt = Object(L.withStyles)(j.getStyle("Form/Fields/MultiSelect", ot))(st),
        ct = {
      PaperProps: {
        style: {
          border: "1px solid #ececec",
          maxHeight: 224,
          width: 250,
          whiteSpace: "normal"
        }
      }
    },
        ut = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          success: !1,
          pending: !1,
          value: n.props.value
        }, n.handleChange = n.handleChange.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handleChange",
        value: function value(e) {
          var t = this,
              n = e.target.value;
          this.setState(u({}, this.state, {
            success: !1,
            pending: !!this.props.instant,
            value: n
          })), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function e() {
            var r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.resolve(t.props.onChange(n || null));

                  case 2:
                    r = e.sent, t.setState(u({}, t.state, {
                      success: r,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), U) : this.props.onChange(n);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.xs,
              a = t.sm,
              o = t.md,
              i = t.lg,
              s = t.xl,
              l = t.readOnly,
              c = t.disabled,
              u = t.label,
              p = t.placeholder,
              d = t.dontShowLock,
              h = void 0 !== d && d,
              f = t.override,
              m = void 0 === f ? {} : f,
              g = t.options,
              v = t.variant,
              y = this.props.error && !this.props.readOnly && !this.state.pending,
              b = this.state.success && !this.props.readOnly && !this.state.pending;

          if (l) {
            var x = g.find(function (t) {
              return "object" == typeof t && t.value === e.props.value || "object" != typeof t && t === e.props.value;
            }),
                w = "object" == typeof x ? x.label : x;
            return k.a.createElement(X, Object.assign({
              xs: r,
              sm: a,
              md: o,
              lg: i,
              xl: s,
              readOnly: l,
              dontShowLock: h,
              disabled: c,
              label: u
            }, {
              value: w || ""
            }));
          }

          var E = l ? this.props.value : this.state.value;
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: r,
            sm: a,
            md: o,
            lg: i,
            xl: s
          }), k.a.createElement("div", {
            className: "instant-form-control"
          }, k.a.createElement(T.FormControl, {
            className: n.formControl
          }, (u || "" === u) && k.a.createElement(T.InputLabel, {
            className: B()([b ? n.success : "", y ? n.danger : ""]),
            classes: {
              root: "fullField" === v && n.fullFieldLabel,
              shrink: "fullField" === v && n.fullFieldLabelShrink
            }
          }, this.props.label, this.state.pending && k.a.createElement(T.CircularProgress, {
            className: n.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), l && k.a.createElement(q.FontAwesomeIcon, {
            className: n.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), y && k.a.createElement(q.FontAwesomeIcon, {
            className: n.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), b && k.a.createElement(q.FontAwesomeIcon, {
            className: n.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement(T.Select, {
            style: {
              whiteSpace: "normal"
            },
            classes: {
              root: m.select,
              selectMenu: B()(["fullField" === v && n.fullFieldSelect, c ? n.disabledCursor : "", p && "" === E ? n.placeholder : ""])
            },
            value: p && "" === E ? "placeholder" : E,
            readOnly: l,
            disabled: c || l,
            onChange: this.handleChange,
            input: k.a.createElement(T.Input, {
              className: B()(["fullField" !== v ? b ? n.inputSuccess : y ? n.inputError : l ? n.inputReadonly : n.input : l ? n.inputReadonly : n.fullFieldRoot]),
              classes: {
                input: B()(["fullField" === v && !l && n.fullFieldInput, m.input])
              }
            }),
            MenuProps: ct
          }, !!p && k.a.createElement(T.MenuItem, {
            value: "placeholder",
            disabled: !0
          }, p), this.props.options.map(function (e) {
            return "object" == typeof e ? k.a.createElement(T.MenuItem, {
              key: e.value,
              value: e.value
            }, e.label) : k.a.createElement(T.MenuItem, {
              key: e,
              value: e
            }, e);
          }))), y && k.a.createElement(T.Typography, {
            className: B()([y ? n.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error)));
        }
      }]), t;
    }(),
        pt = Object(L.withStyles)(j.getStyle("Form/Fields/Select", ot))(ut),
        dt = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          success: !1,
          pending: !1,
          value: n.props.value
        }, n.handleChange = n.handleChange.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentWillUnmount",
        value: function value() {
          this.timer && window.clearTimeout(this.timer);
        }
      }, {
        key: "handleChange",
        value: function value(e) {
          var t = this,
              n = e.target.value;
          this.setState({
            value: n,
            success: !1,
            pending: !!this.props.instant
          }), this.timer && window.clearTimeout(this.timer), this.props.instant ? this.timer = window.setTimeout(l(i.a.mark(function e() {
            var r;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, Promise.resolve(t.props.onChange(n || null));

                  case 2:
                    r = e.sent, t.setState(u({}, t.state, {
                      success: r,
                      pending: !1
                    })), t.state.success && window.setTimeout(function () {
                      t.setState(u({}, t.state, {
                        success: !1
                      }));
                    }, Y);

                  case 5:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          })), U) : this.props.onChange(n || null);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.xs,
              r = e.sm,
              a = e.md,
              o = e.lg,
              i = e.xl,
              s = e.readOnly,
              l = e.disabled,
              c = e.variant,
              u = this.props.error && !this.props.readOnly && !this.state.pending,
              p = this.state.success && !this.props.readOnly && !this.state.pending;
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: n,
            sm: r,
            md: a,
            lg: o,
            xl: i
          }), k.a.createElement(T.FormControl, {
            className: t.formControl
          }, k.a.createElement(T.InputLabel, {
            className: B()([t.label, !!u && t.labelError]),
            classes: {
              root: "fullField" === c && t.fullFieldLabel,
              shrink: "fullField" === c && t.fullFieldLabelShrink
            }
          }, this.props.label, this.state.pending && k.a.createElement(T.CircularProgress, {
            className: t.default,
            style: {
              marginLeft: "5px",
              display: "inline-block"
            },
            size: 13
          }), s && k.a.createElement(q.FontAwesomeIcon, {
            className: t.default,
            style: {
              marginLeft: "5px"
            },
            icon: V.faLockAlt
          }), u && k.a.createElement(q.FontAwesomeIcon, {
            className: t.danger,
            style: {
              marginLeft: "5px"
            },
            icon: V.faExclamationCircle
          }), p && k.a.createElement(q.FontAwesomeIcon, {
            className: t.success,
            style: {
              marginLeft: "5px"
            },
            icon: V.faCheck
          })), k.a.createElement(T.Input, {
            type: this.props.readOnly ? "text" : "time",
            className: B()(["fullField" !== c ? p ? t.inputSuccess : u ? t.inputError : s ? t.inputReadonly : t.input : s ? t.inputReadonly : t.fullFieldRoot]),
            classes: {
              input: "fullField" === c && !s && t.fullFieldInput
            },
            onChange: this.handleChange,
            value: this.props.readOnly ? this.props.value || "-" : this.state.value,
            readOnly: s,
            disabled: l
          })), u && k.a.createElement(T.Typography, {
            className: B()([u ? t.danger : ""]),
            variant: "body2",
            gutterBottom: !0,
            style: {
              display: "inline"
            }
          }, this.props.error));
        }
      }]), t;
    }(),
        ht = Object(L.withStyles)(j.getStyle("Form/Fields/Time", nt))(dt);

    function ft(e) {
      return function (e) {
        if (Array.isArray(e)) {
          for (var t = 0, n = new Array(e.length); t < e.length; t++) {
            n[t] = e[t];
          }

          return n;
        }
      }(e) || function (e) {
        if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
      }();
    }

    var mt,
        gt = n(18),
        vt = n(19),
        yt = n(14),
        bt = n(20),
        xt = function xt(e) {
      return function (t) {
        return {
          delete: {
            border: "1px solid " + e.palette.danger,
            backgroundColor: e.palette.danger,
            color: "#fff"
          },
          chips: {
            margin: "5px 10px 3px 0px",
            color: "#fff"
          },
          chipsOutlined: {
            margin: "5px 10px 3px 0px"
          },
          addMenu: {
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.5)"
          },
          pending: {
            margin: "9px 0px"
          }
        };
      };
    },
        wt = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).change = function (e) {
          (0, n.props.onChange)(e);
        }, n.closeMenu = function () {
          n.setState(u({}, n.state, {
            add: null
          }));
        }, n.getContent = function (e, t, r) {
          var a = n.state.optionsToConfirm,
              o = n.props,
              i = o.classes,
              s = (o.onChange, o.readOnly);
          return s || -1 === a.indexOf(t) ? k.a.createElement("span", null, e, !s && k.a.createElement(q.FontAwesomeIcon, {
            icon: vt.faTrash,
            style: {
              margin: "0px 0px 0px 10px",
              cursor: "pointer"
            },
            onClick: n.setConfirmDeleteFactory(t, !0)
          })) : k.a.createElement("span", null, "Wollen Sie ", k.a.createElement("b", null, e), " löschen?", k.a.createElement("span", {
            style: {
              margin: "0px 0px 0px 10px"
            }
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: gt.faCheck,
            style: {
              margin: "0px 0px 0px 0px",
              cursor: "pointer"
            },
            className: i.deleteCheck,
            onClick: n.setDeleteFactory(t)
          }), k.a.createElement(q.FontAwesomeIcon, {
            icon: yt.faTimes,
            style: {
              margin: "0px 0px 0px 10px",
              cursor: "pointer"
            },
            onClick: n.setConfirmDeleteFactory(t, !1)
          })));
        }, n.setAddValueFactory = function (e) {
          var t = g(g(n)),
              r = t.change,
              a = t.closeMenu;
          return function () {
            r([].concat(ft(n.props.value), [e])), a();
          };
        }, n.setConfirmDeleteFactory = function (e, t) {
          return function () {
            var r = u({}, n.state);
            r.optionsToConfirm = t ? [].concat(ft(n.state.optionsToConfirm), [e]) : ft(n.state.optionsToConfirm).filter(function (t) {
              return t !== e;
            }), n.setState(r);
          };
        }, n.setDeleteFactory = function (e) {
          var t = g(g(n)),
              r = t.change,
              a = t.setConfirmDeleteFactory,
              o = t.props,
              i = a(e);
          return function () {
            r(ft(o.value.filter(function (t) {
              return t !== e;
            }))), i();
          };
        }, n.state = {
          optionsToConfirm: [],
          add: null
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.xs,
              o = t.sm,
              i = t.md,
              s = t.lg,
              l = t.xl,
              c = t.options,
              p = t.value,
              d = t.primary,
              h = t.variant,
              f = t.readOnly,
              m = t.pending,
              g = t.justify,
              v = a.Fab,
              y = this.state,
              b = y.optionsToConfirm,
              x = y.add,
              w = [],
              E = c.filter(function (e) {
            var t = "object" == typeof e ? e.value : e,
                n = p.indexOf(t) > -1;
            return n || w.push(e), n;
          });
          return k.a.createElement(T.Grid, Object.assign({
            item: !0
          }, {
            xs: r,
            sm: o,
            md: i,
            lg: s,
            xl: l
          }), k.a.createElement(T.Grid, {
            container: !0,
            justify: "right" === g ? "flex-end" : "flex-start"
          }, E.map(function (t) {
            var r = t,
                a = t;
            "object" == typeof t && (a = t.value, r = r.label);
            var o = !f && b.indexOf(a) > -1,
                i = e.getContent(r, a, o);
            return k.a.createElement(T.Chip, {
              key: a,
              className: B()(["outlined" === h ? n.chipsOutlined : n.chips, o ? n.delete : ""]),
              label: i,
              color: d && !o ? "primary" : "default",
              variant: o ? "outlined" : h || "default"
            });
          }), !f && E.length < c.length && !m && k.a.createElement(v, {
            "aria-owns": x ? "add-options" : void 0,
            "aria-haspopup": "true",
            variant: "success",
            icon: bt.faPlus,
            onClick: function onClick(t) {
              e.setState(u({}, e.state, {
                add: t.currentTarget
              }));
            }
          }), !f && E.length < c.length && Boolean(x) && !m && k.a.createElement(T.Menu, {
            id: "simple-menu",
            anchorEl: x,
            open: Boolean(x),
            onClose: this.closeMenu,
            classes: {
              paper: n.addMenu
            }
          }, w.map(function (t) {
            var n = "object" == typeof t ? t.label : t,
                r = "object" == typeof t ? t.value : t;
            return k.a.createElement(T.MenuItem, {
              key: r,
              onClick: e.setAddValueFactory(r)
            }, n);
          })), m && k.a.createElement(T.CircularProgress, {
            className: n.pending,
            size: 22
          })));
        }
      }]), t;
    }(),
        kt = Object(L.withStyles)(j.getStyle("Form/Fields/Select", xt))(wt),
        Et = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          authenticated: !1,
          loginForm: !0,
          login: {
            user: "",
            password: "",
            error: !1
          },
          resetCredentialsForm: !1,
          resetCredentials: {
            type: "",
            state: "selectType",
            email: ""
          },
          challengesForm: !1,
          challenges: {
            required: [],
            user: "",
            password: "",
            passwordTwo: "",
            session: "",
            errors: {
              user: !1,
              password: !1,
              passwordTwo: !1
            }
          }
        }, n.renderLoginForm = n.renderLoginForm.bind(g(g(n))), n.renderResetCredentialsForm = n.renderResetCredentialsForm.bind(g(g(n))), n.reset = n.reset.bind(g(g(n))), n.login = n.login.bind(g(g(n))), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentDidMount",
        value: function value() {
          this.setState(u({}, this.state, {
            authenticated: this.props.autoLogin(this.props.on)
          }));
        }
      }, {
        key: "reset",
        value: function () {
          var e = l(i.a.mark(function e(t) {
            var n, r, a, o, s;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (n = this.state.resetCredentials, r = n.email, a = n.type, t.togglePending(!0), e.prev = 2, "password" !== a) {
                      e.next = 6;
                      break;
                    }

                    return e.next = 6, this.props.resetPassword(r);

                  case 6:
                    if ("account" !== a) {
                      e.next = 9;
                      break;
                    }

                    return e.next = 9, this.props.resetAccount(r);

                  case 9:
                    t.togglePending(!1), (o = u({}, this.state)).resetCredentials.state = "success", this.setState(o), e.next = 20;
                    break;

                  case 15:
                    e.prev = 15, e.t0 = e.catch(2), (s = u({}, this.state)).resetCredentials.state = "error", this.setState(s);

                  case 20:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[2, 15]]);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "login",
        value: function () {
          var e = l(i.a.mark(function e(t) {
            var n, r, a, o, s, l;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return n = this.state.login, r = n.user, a = n.password, t.togglePending(!0), e.prev = 2, e.next = 5, this.props.login(r, a, this.props.on);

                  case 5:
                    if (!0 !== (o = e.sent)) {
                      e.next = 9;
                      break;
                    }

                    return this.setState(u({}, this.state, {
                      authenticated: !0
                    })), e.abrupt("return", !0);

                  case 9:
                    o.challenges.length && (t.togglePending(!1), (s = u({}, this.state)).loginForm = !1, s.challengesForm = !0, s.challenges.required = o.challenges, s.challenges.session = o.session, this.setState(s)), e.next = 18;
                    break;

                  case 12:
                    e.prev = 12, e.t0 = e.catch(2), t.togglePending(!1), l = u({}, this.state), "forbidden" === e.t0.code && 2 === e.t0.errors.filter(function (e) {
                      return ("username" === e.key || "password" === e.key) && "notValid" === e.error;
                    }).length ? l.login.error = "invalidCredentials" : l.login.error = "generalError", this.setState(l);

                  case 18:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[2, 12]]);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "challenge",
        value: function () {
          var e = l(i.a.mark(function e(t) {
            var n, r, a, o, s, l, c, p, d;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    if (n = this.state.challenges, r = n.required, a = n.user, o = n.password, s = n.passwordTwo, l = n.session, o === s) {
                      e.next = 6;
                      break;
                    }

                    return (c = u({}, this.state)).challenges.errors.passwordTwo = 'Dieses Passwort entspricht nicht dem im Feld "Passwort".', this.setState(c), e.abrupt("return", !1);

                  case 6:
                    return t.togglePending(!0), p = r.map(function (e) {
                      var t = {
                        type: e
                      };
                      if ("change_invitation_username" === e || "change_username" === e) t.username = a;else {
                        if ("change_password" !== e && "change_invitation_password" !== e) throw {
                          code: "unknownUserChallenge",
                          message: e
                        };
                        t.password = o;
                      }
                      return t;
                    }), e.prev = 8, e.next = 11, this.props.challenge(p, l, this.props.on);

                  case 11:
                    this.setState(u({}, this.state, {
                      authenticated: !0
                    })), e.next = 24;
                    break;

                  case 14:
                    if (e.prev = 14, e.t0 = e.catch(8), "validationError" !== e.t0.code) {
                      e.next = 23;
                      break;
                    }

                    (d = u({}, this.state)).challenges.errors = {
                      user: !1,
                      password: !1,
                      passwordTwo: !1
                    }, e.t0.errors.forEach(function (e) {
                      var t = e.error;

                      switch (e.error) {
                        case "outOfRange":
                          t = "Dieses Feld benötigt eine Mindestlänge von " + e.min + " und eine Maximiallänge von " + e.max + " zeichen.";
                          break;

                        case "notSet":
                          t = "Dieses Feld ist ein Pflichtfeld.";
                      }

                      switch (e.key) {
                        case "username":
                          d.challenges.errors.user = t;
                          break;

                        case "password":
                          d.challenges.errors.password = t;
                      }
                    }), this.setState(d), e.next = 24;
                    break;

                  case 23:
                    throw e.t0;

                  case 24:
                    t.togglePending(!1);

                  case 25:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this, [[8, 14]]);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "renderLoginForm",
        value: function value() {
          var e = this;
          return k.a.createElement(H, {
            label: "Anmelden",
            primary: !0
          }, k.a.createElement(G, {
            actions: function actions(t) {
              return k.a.createElement(T.Grid, {
                container: !0,
                direction: "row",
                justify: "flex-end"
              }, k.a.createElement(T.Grid, {
                item: !0,
                xs: 12,
                sm: 6,
                style: {
                  paddingTop: "9px"
                }
              }, k.a.createElement(T.Typography, {
                color: "primary",
                style: {
                  cursor: "pointer"
                },
                onClick: function onClick(t) {
                  t.preventDefault();
                  var n = u({}, e.state, {
                    resetCredentialsForm: !0,
                    loginForm: !1
                  });
                  n.resetCredentials.state = "selectType", e.setState(n);
                }
              }, "Zugangsdaten vergessen?")), k.a.createElement(T.Grid, {
                item: !0,
                xs: 12,
                sm: 6,
                style: {
                  textAlign: "right"
                }
              }, k.a.createElement(T.Button, {
                variant: "contained",
                color: "primary",
                type: "submit",
                onClick: function onClick(n) {
                  n.preventDefault(), e.login(t);
                }
              }, "Login")));
            }
          }, k.a.createElement(X, {
            xs: 12,
            label: "Benutzername",
            value: this.state.login.user,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.login.user = t, e.setState(n);
            },
            error: "invalidCredentials" === this.state.login.error && "Benutzername oder Passwort falsch!"
          }), k.a.createElement(X, {
            xs: 12,
            label: "Passwort",
            type: "password",
            value: this.state.login.password,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.login.password = t, e.setState(n);
            },
            error: "invalidCredentials" === this.state.login.error
          })));
        }
      }, {
        key: "renderChallenges",
        value: function value() {
          var e = this,
              t = this.state.challenges.required,
              n = t.indexOf("change_invitation_username") > -1 && t.indexOf("change_invitation_password") > -1,
              r = t.indexOf("change_username") > -1 || t.indexOf("change_invitation_username") > -1;
          return k.a.createElement(H, {
            label: n ? "Erster Login" : "Zurückgestellt",
            primary: !0
          }, n && k.a.createElement(T.Typography, {
            variant: "body1"
          }, "Da dies Ihre erste Anmeldung ist bitten wir Sie Ihren Benutzernamen und Ihr Passwort zu ändern"), !n && k.a.createElement(T.Typography, {
            variant: "body1"
          }, "Sie haben eine ", r ? "Account" : "Passwort", " ", "Zurücksetzung beantragt."), k.a.createElement(G, {
            actions: function actions(t) {
              return k.a.createElement(T.Grid, {
                container: !0,
                direction: "row",
                justify: "flex-end"
              }, k.a.createElement(T.Grid, {
                item: !0,
                xs: 12,
                style: {
                  textAlign: "right"
                }
              }, k.a.createElement(T.Button, {
                variant: "contained",
                color: "primary",
                type: "submit",
                onClick: function onClick(n) {
                  n.preventDefault(), e.challenge(t);
                }
              }, "Ändern")));
            }
          }, r && k.a.createElement(X, {
            xs: 12,
            label: "Neuer Benutzername",
            value: this.state.challenges.user,
            autoComplete: !1,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.challenges.user = t, e.setState(n);
            },
            error: this.state.challenges.errors.user
          }), k.a.createElement(X, {
            xs: 12,
            label: "Neues Passwort",
            type: "password",
            autoComplete: !1,
            value: this.state.challenges.password,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.challenges.password = t, e.setState(n);
            },
            error: this.state.challenges.errors.password
          }), k.a.createElement(X, {
            xs: 12,
            label: "Neues Passwort Wiederholen",
            type: "password",
            autoComplete: !1,
            value: this.state.challenges.passwordTwo,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.challenges.passwordTwo = t, e.setState(n);
            },
            error: this.state.challenges.errors.passwordTwo
          })));
        }
      }, {
        key: "renderResetCredentialsForm",
        value: function value() {
          var e = this;

          if ("setEmail" === this.state.resetCredentials.state) {
            return k.a.createElement(H, {
              label: "Zurücksetzen",
              primary: !0
            }, k.a.createElement(T.Typography, {
              variant: "h5"
            }, "Wie lautet die Emailadresse Ihres Accounts?"), k.a.createElement(G, {
              actions: function actions(t) {
                return k.a.createElement(T.Grid, {
                  container: !0,
                  direction: "row",
                  justify: "flex-end"
                }, k.a.createElement(T.Grid, {
                  item: !0,
                  xs: 12,
                  style: {
                    textAlign: "right"
                  }
                }, k.a.createElement(T.Button, {
                  variant: "contained",
                  color: "default",
                  onClick: function onClick(t) {
                    t.preventDefault();
                    var n = u({}, e.state, {
                      loginForm: !0,
                      resetCredentialsForm: !1
                    });
                    n.resetCredentials.state = "selectType", e.setState(n);
                  }
                }, "Abbrechen"), k.a.createElement(T.Button, {
                  variant: "contained",
                  disabled: "" === e.state.resetCredentials.type,
                  color: "primary",
                  type: "submit",
                  style: {
                    marginLeft: "8px"
                  },
                  onClick: function onClick(n) {
                    n.preventDefault(), e.reset(t);
                  }
                }, "Zurücksetzen")));
              }
            }, k.a.createElement(X, {
              xs: 12,
              label: "Email",
              value: this.state.resetCredentials.email,
              onChange: function onChange(t) {
                var n = u({}, e.state);
                n.resetCredentials.email = t, e.setState(n);
              }
            })));
          }

          if ("success" === this.state.resetCredentials.state) return k.a.createElement(H, {
            label: "Erfolg",
            primary: !0
          }, k.a.createElement(T.Typography, {
            variant: "h4"
          }, "password" === this.state.resetCredentials.type ? "Passwort" : "Account", " ", "zurückgesetzt!"), k.a.createElement(T.Typography, {
            style: {
              marginTop: "16px"
            }
          }, "Sollte ein Account mit dieser Email-Adresse verknüpft sein, erhalten Sie", " ", "password" === this.state.resetCredentials.type ? "ein neues Passwort." : "neue Zugangsdaten.", k.a.createElement("br", null), "Melden Sie sich mit diesen an und folgen Sie den Instruktionen."), k.a.createElement("div", {
            style: {
              textAlign: "right",
              paddingTop: "16px"
            }
          }, k.a.createElement(T.Button, {
            variant: "contained",
            color: "default",
            type: "submit",
            onClick: function onClick(t) {
              t.preventDefault(), e.setState(u({}, e.state, {
                resetCredentialsForm: !1,
                loginForm: !0
              }));
            }
          }, "Zum Login")));
          return k.a.createElement(H, {
            label: "Zurücksetzen",
            primary: !0
          }, k.a.createElement(T.Typography, {
            variant: "h5"
          }, "Was möchten Sie zurücksetzen?"), k.a.createElement(G, {
            actions: function actions(t) {
              return k.a.createElement(T.Grid, {
                container: !0,
                direction: "row",
                justify: "flex-end"
              }, k.a.createElement(T.Grid, {
                item: !0,
                xs: 12,
                style: {
                  textAlign: "right"
                }
              }, k.a.createElement(T.Button, {
                variant: "contained",
                color: "default",
                onClick: function onClick(t) {
                  t.preventDefault();
                  var n = u({}, e.state, {
                    loginForm: !0,
                    resetCredentialsForm: !1
                  });
                  n.resetCredentials.state = "selectType", e.setState(n);
                }
              }, "Abbrechen"), k.a.createElement(T.Button, {
                variant: "contained",
                disabled: "" === e.state.resetCredentials.type,
                color: "primary",
                type: "submit",
                style: {
                  marginLeft: "8px"
                },
                onClick: function onClick(t) {
                  t.preventDefault();
                  var n = u({}, e.state);
                  n.resetCredentials.state = "setEmail", e.setState(n);
                }
              }, "Weiter")));
            }
          }, k.a.createElement(ee, {
            options: [{
              label: "Passwort",
              value: "password"
            }, {
              label: "Benutzername & Passwort",
              value: "account"
            }],
            value: this.state.resetCredentials.type,
            onChange: function onChange(t) {
              var n = u({}, e.state);
              n.resetCredentials.type = t, e.setState(n);
            }
          })));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.state.authenticated,
              t = this.props.children;
          return e && t ? t : e && !t ? k.a.createElement("p", null, "No Content Set") : k.a.createElement(T.Grid, {
            style: {
              marginTop: "25px"
            },
            container: !0,
            spacing: 8,
            justify: "center",
            alignItems: "center"
          }, k.a.createElement(T.Grid, {
            item: !0,
            xs: 12,
            md: 5
          }, k.a.createElement("div", {
            style: {
              height: "100%"
            }
          }, this.state.challengesForm && this.renderChallenges(), this.state.loginForm && this.renderLoginForm(), this.state.resetCredentialsForm && this.renderResetCredentialsForm())));
        }
      }]), t;
    }(),
        Ct = (mt = Object(L.withStyles)(function (e) {
      return {};
    })(Et), Object(E.connect)(F, O)(mt)),
        St = n(10),
        Pt = n(16),
        Ft = n(15),
        Ot = function Ot(e) {
      return function (t) {
        var n,
            r,
            a = {
          closeButton: {
            margin: t.spacing.unit,
            width: "48px",
            height: "48px",
            color: "rgba(255, 255, 255, 0.7)"
          },
          closeButtonHolder: {
            textAlign: "right"
          },
          openMenuButton: {
            margin: t.spacing.unit,
            width: "48px",
            height: "48px",
            color: "rgba(255, 255, 255, 1)"
          },
          signOutButton: {
            margin: t.spacing.unit,
            width: "48px",
            height: "48px",
            color: "rgba(255, 255, 255, 1)",
            paddingLeft: "16px"
          },
          menu: {
            width: "250px",
            backgroundColor: e.palette.thirdly
          },
          iconMenu: {
            width: "25px",
            margin: "0px"
          },
          fontMenu: {
            color: "rgba(255, 255, 255, 0.7)",
            fontWeight: 100
          },
          linkMenu: {
            textDecoration: "none"
          },
          linkList: {
            paddingLeft: "59px",
            margin: "0px",
            listStyle: "none"
          },
          linkListElementNoIcon: {
            paddingLeft: "0px !important"
          },
          linkListElementText: {
            fontSize: "0.9rem",
            paddingLeft: "0px",
            lineHeight: "1rem"
          },
          linkListElementHolder: {
            padding: "8px 16px",
            borderLeft: "1px solid rgba(255, 255, 255, 0.4)"
          },
          pendingIcon: {
            color: "rgba(255, 255, 255, 0.7)",
            float: "right"
          },
          activeLink: {
            color: "rgba(255, 255, 255, 1)"
          },
          dividerMenu: {
            backgroundColor: "rgba(255, 255, 255, 0.12)"
          },
          rippleMenu: {
            color: e.palette.primary
          },
          appBarOpen: {},
          contentOpen: (n = {
            padding: "64px 8px 8px 258px"
          }, c(n, t.breakpoints.up("xs") + " and (orientation: landscape)", {
            padding: "72px 8px 8px 258px"
          }), c(n, t.breakpoints.up("sm"), {
            padding: "72px 8px 8px 258px"
          }), n),
          content: (r = {}, c(r, t.breakpoints.down("sm"), {
            padding: "72px 8px 8px 8px"
          }), c(r, t.breakpoints.up("sm"), {
            padding: "72px 8px 8px 8px"
          }), r)
        };
        return a.appBarOpen.marginLeft = a.menu.width, a.appBarOpen.width = "calc(100% - " + a.menu.width + ")", a;
      };
    },
        Lt = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {
          menu: window.innerWidth > 559,
          windowSize: window.innerWidth < 560 ? "xs" : "lg"
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentDidMount",
        value: function value() {
          window.addEventListener("resize", this.onWindowResize.bind(this));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.onWindowResize.bind(this));
        }
      }, {
        key: "onWindowResize",
        value: function value() {
          var e = window.innerWidth,
              t = this.state,
              n = t.windowSize;
          t.menu;
          e < 560 && "xs" !== n ? this.setState(u({}, this.state, {
            windowSize: "xs",
            menu: !1
          })) : e > 559 && "lg" !== n && this.setState(u({}, this.state, {
            windowSize: "lg"
          }));
        }
      }, {
        key: "toggleMenu",
        value: function value(e) {
          var t = e;
          void 0 !== t && (t = !this.state.menu), this.setState(u({}, this.state, {
            menu: t
          }));
        }
      }, {
        key: "renderNavigationElements",
        value: function value(e, t) {
          var n,
              r = this,
              a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "",
              o = this.props,
              i = o.classes,
              s = o.routing,
              l = !(!s || !e.path) && e.path === s.match.path;
          return k.a.createElement("div", {
            key: "navigation-element-" + t
          }, (n = k.a.createElement(T.ListItem, {
            classes: {
              root: B()([i.rippleMenu, a && i.linkListElementHolder])
            },
            button: !0
          }, e.icon && k.a.createElement(T.ListItemIcon, {
            classes: {
              root: B()([i.fontMenu, i.iconMenu, l && i.activeLink])
            }
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: e.icon
          })), k.a.createElement(T.ListItemText, {
            classes: {
              root: B()([a && !e.icon && i.linkListElementNoIcon, a && i.linkListElementText]),
              primary: B()([i.fontMenu, l && i.activeLink, a && i.linkListElementText])
            },
            inset: !0,
            primary: k.a.createElement("span", null, e.name, e.pending && k.a.createElement(T.CircularProgress, {
              size: 12,
              classes: {
                root: i.pendingIcon
              }
            }))
          })), e.path ? k.a.createElement("a", {
            key: a + "navigation-link-" + t,
            href: e.path,
            className: i.linkMenu
          }, n) : k.a.createElement("span", {
            key: a + "navigation-element-" + t
          }, n)), e.elements && k.a.createElement("ul", {
            className: i.linkList
          }, e.elements.map(function (e, n) {
            return k.a.createElement("li", {
              key: "list-element" + t + "-" + n,
              className: i.linkListElement
            }, r.renderNavigationElements(e, n, "list-element" + t));
          })));
        }
      }, {
        key: "renderLinks",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.links,
              r = t.classes;
          return k.a.createElement(T.List, {
            component: "nav",
            subheader: k.a.createElement(T.ListSubheader, {
              classes: {
                root: r.fontMenu
              },
              component: "div"
            }, "Navigation")
          }, n.map(function (t, n) {
            return e.renderNavigationElements(t, n);
          }));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.page,
              r = t.content,
              a = t.classes,
              o = !(window.innerWidth > 559);
          return k.a.createElement("div", {
            className: "admin-layout"
          }, k.a.createElement(T.AppBar, {
            classes: {
              root: B()([!(!this.state.menu || o) && a.appBarOpen])
            }
          }, k.a.createElement(T.Toolbar, null, !this.state.menu && k.a.createElement(T.IconButton, {
            onClick: function onClick() {
              e.toggleMenu(!0);
            },
            className: a.openMenuButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: Pt.faBars
          })), this.state.menu && window.innerWidth < 560 && k.a.createElement(T.IconButton, {
            className: a.openMenuButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: Pt.faBars
          })), k.a.createElement(T.Typography, {
            variant: "h6",
            color: "inherit",
            style: {
              flexGrow: 1
            }
          }, n), k.a.createElement(T.IconButton, {
            onClick: function onClick() {
              e.props.signOut();
            },
            className: a.signOutButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: Ft.faSignOutAlt
          })))), k.a.createElement(T.SwipeableDrawer, {
            variant: "persistent",
            anchor: "left",
            classes: {
              paper: a.menu
            },
            onClose: function onClose() {
              e.toggleMenu(!1);
            },
            onOpen: function onOpen() {
              e.toggleMenu(!0);
            },
            open: this.state.menu
          }, k.a.createElement("div", {
            className: a.closeButtonHolder
          }, k.a.createElement(T.IconButton, {
            onClick: function onClick() {
              e.toggleMenu(!1);
            },
            className: a.closeButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: yt.faTimes
          }))), k.a.createElement(T.Divider, {
            classes: {
              root: a.dividerMenu
            }
          }), this.renderLinks()), k.a.createElement("main", {
            className: this.state.menu && !o ? a.contentOpen : a.content
          }, r));
        }
      }]), t;
    }(),
        Tt = Object(T.withStyles)(j.getStyle("Layout/Admin", Ot))(Lt),
        Nt = function Nt(e) {
      return function (e) {
        return {};
      };
    },
        Bt = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props.content;
          return k.a.createElement("div", null, k.a.createElement("main", null, e));
        }
      }]), t;
    }(),
        It = Object(L.withStyles)(j.getStyle("Layout/Admin", Nt))(Bt),
        At = function At(e) {
      return function (e) {
        var t;
        return {
          signOutButton: {
            margin: e.spacing.unit,
            width: "48px",
            height: "48px",
            color: "rgba(255, 255, 255, 1)",
            paddingLeft: "16px"
          },
          content: (t = {}, c(t, e.breakpoints.down("sm"), {
            padding: "72px 8px 8px 8px"
          }), c(t, e.breakpoints.up("sm"), {
            padding: "72px 8px 8px 8px"
          }), t)
        };
      };
    },
        Mt = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e))).state = {}, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.page,
              r = t.content,
              a = t.classes;
          return k.a.createElement("div", {
            className: "admin-layout"
          }, k.a.createElement(T.AppBar, null, k.a.createElement(T.Toolbar, null, k.a.createElement(T.Typography, {
            variant: "h6",
            color: "inherit",
            style: {
              flexGrow: 1
            }
          }, n), k.a.createElement(T.IconButton, {
            onClick: function onClick() {
              e.props.signOut();
            },
            className: a.signOutButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: Ft.faSignOutAlt
          })))), k.a.createElement("main", {
            className: a.content
          }, r));
        }
      }]), t;
    }(),
        jt = Object(T.withStyles)(j.getStyle("Layout/Admin", At))(Mt),
        Rt = function Rt(e) {
      return {};
    },
        Dt = function Dt(e) {
      return {
        dispatch: function dispatch(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t && t[n] && e({
            type: t[n],
            payload: r
          });
        }
      };
    },
        Ht = function Ht(e) {
      return function (e) {
        return {
          pendingIconWrapper: {
            height: "calc(100vh -  80px)"
          }
        };
      };
    },
        _t = function (e) {
      function t(e) {
        var n;
        p(this, t), (n = v(this, y(t).call(this, e)))._isMounted = !1;
        var r = "function" == typeof e.content;
        return n.state = {
          content: {
            pending: r,
            toCreate: r ? null : e.content,
            error: !1
          }
        }, n.loadContent = n.loadContent.bind(g(g(n))), r ? n.loadContent() : n.props.dispatch(n.props.on, "contentLoaded"), n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentDidMount",
        value: function value() {
          this._isMounted = !0;
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          this._isMounted = !1;
        }
      }, {
        key: "loadContent",
        value: function () {
          var e = l(i.a.mark(function e() {
            var t, n;
            return i.a.wrap(function (e) {
              for (;;) {
                switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, this.props.content();

                  case 2:
                    t = e.sent, n = u({}, this.state.content, {
                      pending: !1,
                      error: !1,
                      toCreate: t.default
                    }), this._isMounted && this.setState(u({}, this.state, {
                      content: n
                    })), this.props.dispatch(this.props.on, "contentLoaded");

                  case 6:
                  case "end":
                    return e.stop();
                }
              }
            }, e, this);
          }));
          return function () {
            return e.apply(this, arguments);
          };
        }()
      }, {
        key: "getLayout",
        value: function value(e, t) {
          var n = this;

          switch (e) {
            case "admin":
              return k.a.createElement(Tt, Object.assign({}, t, {
                signOut: function signOut() {
                  return n.props.dispatch(n.props.on, "signOut");
                }
              }));

            case "emptyPage":
              return k.a.createElement(It, t);

            case "appBarOnly":
              return k.a.createElement(jt, Object.assign({}, t, {
                signOut: function signOut() {
                  return n.props.dispatch(n.props.on, "signOut");
                }
              }));

            default:
              console.log("LAYOUTER: layout not defined");
          }
        }
      }, {
        key: "protectSite",
        value: function value(e, t) {
          return k.a.createElement(Ct, e.props || {}, t);
        }
      }, {
        key: "renderPendingContent",
        value: function value() {
          var e = this.props.classes;
          return k.a.createElement("div", {
            className: e.pendingIconWrapper
          }, k.a.createElement(_, {
            textAlign: "center"
          }, k.a.createElement(T.CircularProgress, {
            size: 60
          })));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.layout,
              n = e.page,
              r = e.links,
              a = e.contentProps,
              o = e.routing,
              i = e.authenticator,
              s = void 0 === i ? {} : i,
              l = this.state.content,
              c = k.a.createElement("div", null, this.getLayout(t, {
            page: n || "",
            links: r || [],
            content: l.pending ? this.renderPendingContent() : k.a.createElement(l.toCreate, u({}, a, {
              routing: o
            })),
            routing: o
          }));
          return k.a.createElement(L.MuiThemeProvider, {
            theme: j.convert("material-ui")
          }, this.props.protected ? this.protectSite(s, c) : c);
        }
      }]), t;
    }(),
        zt = Object(L.withStyles)(j.getStyle("Layouter", Ht))(function (e) {
      return Object(E.connect)(Rt, Dt)(e);
    }(_t)),
        Wt = function Wt(e) {
      return {};
    },
        Gt = function Gt(e) {
      return {
        dispatch: function dispatch(t, n) {
          var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          t && t[n] && e({
            type: t[n],
            payload: r
          });
        }
      };
    },
        qt = function (e) {
      return Object(E.connect)(Wt, Gt)(e);
    }(function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "getVisibleLinks",
        value: function value(e, t) {
          return t.reduce(function (t, n) {
            return e && n.group && -1 === e.indexOf(n.group) || !1 === n.inMenu ? ft(t) : [].concat(ft(t), [{
              path: n.path,
              name: n.name,
              icon: n.icon,
              pending: n.pending,
              elements: n.elements || !1
            }]);
          }, []);
        }
      }, {
        key: "renderContent",
        value: function value(e) {}
      }, {
        key: "renderRoutes",
        value: function value(e, t) {
          var n = this;
          return k.a.createElement(St.Switch, null, t.reduce(function (r, a, o) {
            if (e && a.group && -1 === e.indexOf(a.group)) return ft(r);

            var i = function i(r) {
              return [k.a.createElement(St.Route, {
                exact: !0,
                key: "switch-" + o,
                path: r.path,
                component: Object(St.withRouter)(function (a) {
                  return k.a.createElement(zt, Object.assign({}, n.props.layouter || {}, {
                    layout: r.layout,
                    links: n.getVisibleLinks(e, t),
                    content: r.component,
                    icon: r.icon,
                    page: r.name,
                    protected: r.protected,
                    authenticator: r.authenticator,
                    contentProps: r.props || {},
                    routing: a
                  }));
                })
              })].concat(ft((r.aliasPath || []).map(function (a, i) {
                return k.a.createElement(St.Route, {
                  exact: !0,
                  key: "switch-alias-" + o + "-" + i,
                  path: a,
                  component: Object(St.withRouter)(function (a) {
                    return k.a.createElement(zt, Object.assign({}, n.props.layouter || {}, {
                      layout: r.layout,
                      links: n.getVisibleLinks(e, t),
                      content: r.component,
                      icon: r.icon,
                      page: r.name,
                      protected: r.protected,
                      authenticator: r.authenticator,
                      contentProps: r.props || {},
                      routing: a
                    }));
                  })
                });
              })));
            },
                s = ft(r);

            return a.elements && (s = [].concat(ft(s), ft(a.elements.reduce(function (e, t, n) {
              return [].concat(ft(e), ft(i(t)));
            }, [])))), a.path ? [].concat(ft(s), ft(i(a))) : ft(s);
          }, []));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.group,
              n = e.pages;
          return k.a.createElement(St.BrowserRouter, null, this.renderRoutes(t, n));
        }
      }]), t;
    }()),
        Vt = function Vt(e) {
      return function (t) {
        return {
          holder: {
            margin: "-8px -8px 0px",
            padding: "8px",
            height: "41px"
          },
          fixer: {
            position: "fixed",
            backgroundColor: "#fff",
            margin: "-8px -8px 0px",
            zIndex: 100,
            whiteSpace: "nowrap",
            borderBottom: "1px solid " + e.palette.background
          },
          childrenHolder: {
            padding: "8px"
          }
        };
      };
    },
        Ut = function (e) {
      function t(e) {
        var n;
        return p(this, t), (n = v(this, y(t).call(this, e)))._isMounted = !1, n.holder = k.a.createRef(), n.state = {
          barStyle: {
            display: "none"
          }
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "componentDidMount",
        value: function value() {
          this._isMounted = !0, this.updateDimensions(), window.addEventListener("resize", this.updateDimensions.bind(this));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          window.removeEventListener("resize", this.updateDimensions.bind(this)), this._isMounted = !1;
        }
      }, {
        key: "updateDimensions",
        value: function value() {
          var e = {
            display: "none"
          };
          this.holder.current && (e = {
            width: this.holder.current.clientWidth
          }), this._isMounted && this.setState(u({}, this.state, {
            barStyle: e
          }));
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.children,
              r = this.state.barStyle;
          return k.a.createElement("div", {
            ref: this.holder,
            className: t.holder
          }, k.a.createElement("div", {
            className: t.fixer,
            style: r
          }, k.a.createElement("div", {
            className: t.childrenHolder
          }, n)), k.a.createElement("div", {
            className: t.placeholder
          }));
        }
      }]), t;
    }(),
        Yt = Object(L.withStyles)(j.getStyle("SubAppBar", Vt))(Ut),
        Kt = function Kt(e) {
      return function (t) {
        return {
          default: {
            backgroundColor: e.palette.grey,
            color: "#000",
            "&:hover": {
              backgroundColor: A()(e.palette.grey).darken(.2).hex(),
              color: "#000"
            }
          },
          primary: {
            backgroundColor: e.palette.primary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.primary).darken(.2).hex(),
              color: "#fff"
            }
          },
          secondary: {
            backgroundColor: e.palette.secondary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.secondary).darken(.2).hex(),
              color: "#fff"
            }
          },
          success: {
            backgroundColor: e.palette.success,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.success).darken(.2).hex(),
              color: "#fff"
            }
          },
          danger: {
            backgroundColor: e.palette.danger,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.danger).darken(.2).hex(),
              color: "#fff"
            }
          },
          warning: {
            backgroundColor: e.palette.warning,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.warning).darken(.2).hex(),
              color: "#fff"
            }
          },
          fabLabel: {
            fontSize: "1.5em"
          },
          fabSmall: {
            width: "25px",
            height: "25px",
            minHeight: "25px"
          },
          fabMedium: {
            width: "36px",
            height: "36px"
          }
        };
      };
    },
        Zt = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.icon,
              r = e.variant,
              a = e.style,
              o = e.onClick,
              i = e.override,
              s = void 0 === i ? {} : i,
              l = e.small,
              c = e.medium,
              u = r || "default";
          return k.a.createElement(T.Fab, Object.assign({
            className: t[u],
            size: "small",
            classes: {
              root: B()([l && t.fabSmall, c && t.fabMedium, s.button]),
              label: B()([t.fabLabel, s.icon])
            }
          }, {
            style: a,
            onClick: o
          }), k.a.createElement(q.FontAwesomeIcon, {
            icon: n
          }));
        }
      }]), t;
    }(),
        $t = Object(L.withStyles)(j.getStyle("Buttons/Fab", Kt))(Zt),
        Xt = function Xt(e) {
      return function (t) {
        return {
          btn: {},
          default: {
            backgroundColor: e.palette.grey,
            color: "#000",
            "&:hover": {
              backgroundColor: A()(e.palette.grey).darken(.2).hex(),
              color: "#000"
            }
          },
          primary: {
            backgroundColor: e.palette.primary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.primary).darken(.2).hex(),
              color: "#fff"
            }
          },
          secondary: {
            backgroundColor: e.palette.secondary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.secondary).darken(.2).hex(),
              color: "#fff"
            }
          },
          success: {
            backgroundColor: e.palette.success,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.success).darken(.2).hex(),
              color: "#fff"
            }
          },
          danger: {
            backgroundColor: e.palette.danger,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.danger).darken(.2).hex(),
              color: "#fff"
            }
          },
          warning: {
            backgroundColor: e.palette.warning,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.warning).darken(.2).hex(),
              color: "#fff"
            }
          },
          switchRoot: {
            width: "36px"
          },
          switchIcon: {
            boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.7)"
          },
          switchBase: {
            width: "22px",
            height: "36px"
          }
        };
      };
    },
        Jt = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.variant,
              r = e.style,
              a = e.onClick,
              o = e.children,
              i = e.override,
              s = void 0 === i ? {} : i,
              l = n || "default";
          return k.a.createElement(T.Button, Object.assign({
            className: B()([t.btn, t[l], s.button]),
            variant: "contained"
          }, {
            style: r,
            onClick: a
          }), o);
        }
      }]), t;
    }(),
        Qt = Object(L.withStyles)(j.getStyle("Buttons/Button", Xt))(Jt),
        en = function en(e) {
      return function (t) {
        return {
          holder: {
            display: "inline"
          },
          default: {
            backgroundColor: e.palette.grey,
            color: "#000",
            "&:hover": {
              backgroundColor: A()(e.palette.grey).darken(.2).hex(),
              color: "#000"
            }
          },
          primary: {
            backgroundColor: e.palette.primary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.primary).darken(.2).hex(),
              color: "#fff"
            }
          },
          secondary: {
            backgroundColor: e.palette.secondary,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.secondary).darken(.2).hex(),
              color: "#fff"
            }
          },
          success: {
            backgroundColor: e.palette.success,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.success).darken(.2).hex(),
              color: "#fff"
            }
          },
          danger: {
            backgroundColor: e.palette.danger,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.danger).darken(.2).hex(),
              color: "#fff"
            }
          },
          warning: {
            backgroundColor: e.palette.warning,
            color: "#fff",
            "&:hover": {
              backgroundColor: A()(e.palette.warning).darken(.2).hex(),
              color: "#fff"
            }
          },
          badge: {
            top: "-5px",
            right: "-5px"
          },
          drawer: {
            width: "250px"
          },
          drawerContent: {
            padding: "8px"
          },
          dividerMenu: {
            backgroundColor: "rgba(0, 0, 0, 0.12)"
          },
          closeButton: {
            margin: t.spacing.unit,
            width: "48px",
            height: "48px"
          }
        };
      };
    },
        tn = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).state = {
          open: !1
        }, n.toggleDrawer = function () {
          n.setState(u({}, n.state, {
            open: !n.state.open
          }));
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.position,
              a = t.children,
              o = t.variant,
              i = t.label,
              s = t.style,
              l = t.badge,
              c = t.override,
              u = void 0 === c ? {} : c;
          return k.a.createElement("div", {
            className: n.holder,
            style: s
          }, k.a.createElement(T.Badge, {
            classes: {
              badge: B()([n.badge, u.badge])
            },
            badgeContent: l,
            invisible: !Boolean(l) && 0 !== l,
            color: "secondary"
          }, k.a.createElement(Qt, {
            variant: o,
            onClick: this.toggleDrawer
          }, i)), k.a.createElement(T.Drawer, {
            anchor: r,
            open: this.state.open,
            onClose: function onClose() {
              return e.toggleDrawer(!1);
            },
            classes: {
              paper: n.drawer
            }
          }, k.a.createElement("div", null, k.a.createElement(T.IconButton, {
            onClick: function onClick() {
              e.toggleDrawer();
            },
            className: n.closeButton
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: V.faTimes
          }))), k.a.createElement("div", {
            className: n.drawerContent
          }, a)));
        }
      }]), t;
    }(),
        nn = Object(L.withStyles)(j.getStyle("Buttons/DrawerButton", en))(tn),
        rn = function (e) {
      function t() {
        return p(this, t), v(this, y(t).apply(this, arguments));
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classes,
              n = e.variant,
              r = void 0 === n ? "primary" : n,
              a = e.style,
              o = e.value,
              i = e.onChange,
              s = e.override,
              l = void 0 === s ? {} : s;
          return k.a.createElement(T.Switch, Object.assign({
            classes: u({}, l, {
              root: B()([t.switchRoot, l.root]),
              icon: B()([t.switchIcon, l.icon]),
              switchBase: B()([t.switchBase, l.switchBase])
            }),
            checked: o,
            onChange: function onChange(e) {
              i(Boolean(e.target.checked));
            },
            value: "switch",
            color: r,
            variant: "contained"
          }, {
            style: a
          }));
        }
      }]), t;
    }(),
        an = Object(L.withStyles)(j.getStyle("Buttons/Button", Xt))(rn),
        on = function on(e) {
      return function (t) {
        return {
          wrapper: {
            overflow: "hidden",
            height: "46px"
          },
          holder: {
            margin: "0px 4px"
          },
          recordsPerPageHolder: {
            textAlign: "left"
          },
          paginationHolder: {
            textAlign: "right",
            whiteSpace: "nowrap",
            overflowX: "scroll"
          },
          menu: {
            border: "1px solid " + e.palette.default
          },
          paginationBtn: {
            margin: "4px 0px",
            padding: "6px 12px",
            fontSize: "1rem",
            backgroundColor: "rgba(255, 255, 255, 0)",
            width: "38px",
            height: "38px",
            minWidth: "inherit",
            lineHeight: "1.5rem",
            "&:hover": {
              backgroundColor: e.palette.primary,
              color: "#fff"
            }
          },
          paginationBtnDisabled: {
            color: e.palette.default,
            cursor: "not-allowed",
            "&:hover": {
              color: e.palette.default,
              backgroundColor: "rgba(255, 255, 255, 0)"
            }
          },
          paginationBtnActive: {
            color: e.palette.secondary
          },
          paginationLabel: {
            lineHeight: "1.5rem"
          },
          RecordsPerPageText: {
            display: "inline-block",
            color: e.palette.fontSubtle,
            margin: "4px 4px",
            cursor: "pointer",
            marginTop: "14px",
            "&:hover": {
              color: e.palette.primary
            }
          },
          text: {
            display: "inline-block",
            color: e.palette.fontSubtle,
            margin: "4px 4px"
          },
          "@media (max-width: 599px)": {
            RecordsPerPageText: {
              marginTop: "4px"
            },
            recordsPerPageHolder: {
              textAlign: "right"
            }
          }
        };
      };
    },
        sn = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).state = {
          anchorRecordsPerPage: null
        }, n.firstPage = function () {
          var e = n.props;
          (0, e.onChange)(e.from);
        }, n.previous = function () {
          var e = n.props,
              t = e.onChange,
              r = e.current;
          r > e.from && t(r - 1);
        }, n.next = function () {
          var e = n.props,
              t = e.onChange,
              r = e.current;
          r < e.to && t(r + 1);
        }, n.lastPage = function () {
          var e = n.props;
          (0, e.onChange)(e.to);
        }, n.changeRecordsPerPage = function (e, t) {
          n.toggleRecordsPerPageMenu(e), (0, n.props.onChangeRecordsPerPage)(t);
        }, n.toggleRecordsPerPageMenu = function (e) {
          Boolean(n.state.anchorRecordsPerPage) ? n.setState(u({}, n.state, {
            anchorRecordsPerPage: null
          })) : n.setState(u({}, n.state, {
            anchorRecordsPerPage: e.currentTarget
          }));
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.toggleRecordsPerPageMenu,
              t = this.changeRecordsPerPage,
              n = this.props,
              r = n.classes,
              a = n.current,
              o = n.from,
              i = n.to,
              s = n.recordsPerPage,
              l = n.recordsPerPageOptions,
              c = this.state.anchorRecordsPerPage,
              u = i - o + 1;
          return k.a.createElement("div", null, k.a.createElement("div", {
            className: r.holder
          }, k.a.createElement(T.Grid, {
            container: !0,
            size: 4
          }, k.a.createElement(T.Grid, {
            item: !0,
            xs: 12,
            sm: 6,
            className: r.recordsPerPageHolder
          }, k.a.createElement(T.Typography, {
            "aria-owns": c ? "simple-menu" : void 0,
            "aria-haspopup": "true",
            variant: "caption",
            className: r.RecordsPerPageText,
            onClick: e
          }, "Einträge pro Seite ", s, " ", l && l.length && k.a.createElement(q.FontAwesomeIcon, {
            style: {
              position: "relative",
              top: "1px"
            },
            icon: V.faCaretDown
          })), l && l.length && k.a.createElement(T.Menu, {
            id: "simple-menu",
            anchorEl: c,
            open: Boolean(c),
            onClose: e,
            classes: {
              paper: r.menu
            }
          }, l.map(function (e) {
            return k.a.createElement(T.MenuItem, {
              key: "recordsPerPageOption-" + e,
              onClick: function onClick(n) {
                return t(n, e);
              }
            }, e);
          }))), k.a.createElement(T.Grid, {
            item: !0,
            xs: 12,
            sm: 6,
            className: r.wrapper
          }, k.a.createElement("div", {
            className: r.paginationHolder
          }, k.a.createElement(T.Fab, {
            classes: {
              root: B()([r.paginationBtn, a <= o ? r.paginationBtnDisabled : r.paginationBtnActive]),
              label: r.paginationLabel
            },
            onClick: this.firstPage,
            color: "default",
            variant: "round"
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: V.faChevronDoubleLeft
          })), k.a.createElement(T.Fab, {
            classes: {
              root: B()([r.paginationBtn, a <= o ? r.paginationBtnDisabled : r.paginationBtnActive]),
              label: r.paginationLabel
            },
            onClick: this.previous,
            color: "default",
            variant: "round"
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: V.faChevronLeft
          })), k.a.createElement(T.Typography, {
            className: r.text,
            variant: "caption"
          }, a, " von ", u), k.a.createElement(T.Fab, {
            classes: {
              root: B()([r.paginationBtn, a >= i ? r.paginationBtnDisabled : r.paginationBtnActive])
            },
            onClick: this.next,
            color: "default",
            variant: "round"
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: V.faChevronRight
          })), k.a.createElement(T.Fab, {
            classes: {
              root: B()([r.paginationBtn, a >= i ? r.paginationBtnDisabled : r.paginationBtnActive])
            },
            onClick: this.lastPage,
            color: "default",
            variant: "round"
          }, k.a.createElement(q.FontAwesomeIcon, {
            icon: V.faChevronDoubleRight
          })))))));
        }
      }]), t;
    }(),
        ln = Object(L.withStyles)(j.getStyle("Pagination", on))(sn),
        cn = function cn(e) {
      return function (t) {
        return {
          holder: {
            margin: "0px",
            paddingTop: "12px",
            overflow: "hidden",
            height: "27px"
          },
          list: {
            listStyle: "none",
            padding: "0px",
            margin: "0px",
            whiteSpace: "nowrap",
            overflowX: "scroll"
          },
          listItem: {
            display: "inline-block",
            padding: "4px 8px"
          },
          text: {
            cursor: "pointer",
            color: e.palette.fontSubtle
          },
          textActive: {
            cursor: "pointer"
          },
          icon: {
            marginRight: "5px"
          }
        };
      };
    },
        un = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).state = {
          active: null,
          oder: null
        }, n.setActive = function (e) {
          var t = n.state,
              r = t.active,
              a = t.order,
              o = n.props.onChange;
          e === r ? (r = "desc" === a ? null : e, a = null === a ? "asc" : "asc" === a ? "desc" : null, n.setState(u({}, n.state, {
            active: r,
            order: a
          })), o({
            active: r,
            order: a
          })) : (n.setState(u({}, n.state, {
            active: e,
            order: "asc"
          })), o({
            active: e,
            order: "asc"
          }));
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.options,
              a = this.state,
              o = a.active,
              i = a.order;
          return k.a.createElement("div", {
            className: n.holder
          }, k.a.createElement("ul", {
            className: n.list
          }, r && r.map(function (t, r) {
            return k.a.createElement("li", {
              key: t + "-" + r,
              className: n.listItem
            }, t === o && k.a.createElement(T.Typography, {
              variant: "body2",
              onClick: function onClick() {
                return e.setActive(t);
              },
              className: n.textActive
            }, k.a.createElement(q.FontAwesomeIcon, {
              icon: "asc" === i ? V.faArrowUp : V.faArrowDown,
              className: n.icon
            }), t), t !== o && k.a.createElement(T.Typography, {
              variant: "caption",
              onClick: function onClick() {
                return e.setActive(t);
              },
              className: n.text
            }, t));
          })));
        }
      }]), t;
    }(),
        pn = Object(L.withStyles)(j.getStyle("Sorting", cn))(un),
        dn = function dn(e) {
      return function (e) {
        return {
          sortHolder: {
            backgroundColor: "#fff"
          },
          elementsHolder: {
            padding: "8px",
            backgroundColor: "#fff"
          },
          paginationHolder: {
            backgroundColor: "#fff"
          }
        };
      };
    },
        hn = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).state = {
          recordsPerPage: n.props.recordsPerPage || 5,
          currentPage: 0,
          currentSorting: {
            active: null,
            order: null
          }
        }, n.getFilteredAndSortedItems = function (e) {
          var t = n.props,
              r = t.filter,
              a = t.sort,
              o = n.state.currentSorting;
          return e.filter(r).sort(function (e, t) {
            return a.function(e, t, o);
          });
        }, n.getElementsForPage = function (e) {
          var t = n.props.currentPage || 0 === n.props.currentPage ? n.props.currentPage : n.state.currentPage,
              r = n.props.recordsPerPage || n.state.recordsPerPage,
              a = n.props.element;
          return e.slice(t * r, t * r + r).map(a);
        }, n.getPages = function (e) {
          var t = n.props.recordsPerPage || n.state.recordsPerPage;
          return Math.ceil(e.length / t);
        }, n.setCurrentPage = function (e) {
          var t = n.props.currentPage;
          t || 0 === t ? n.props.onCurrentPageChange(e - 1) : n.setState(u({}, n.state, {
            currentPage: e - 1
          }));
        }, n.setRecordsPerPage = function (e) {
          n.props.recordsPerPage ? n.props.onRecordsPerPageChange(e) : n.setState(u({}, n.state, {
            recordsPerPage: e
          }));
        }, n.setSorting = function (e) {
          n.setState(u({}, n.state, {
            currentSorting: e
          }));
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = this.getPages,
              n = this.getFilteredAndSortedItems,
              r = this.setCurrentPage,
              a = this.getElementsForPage,
              o = this.setRecordsPerPage,
              i = this.setSorting,
              s = e.classes,
              l = e.items,
              c = e.sort,
              u = e.recordsPerPageOptions,
              p = this.props.currentPage || 0 === this.props.currentPage ? this.props.currentPage : this.state.currentPage,
              d = this.props.recordsPerPage || this.state.recordsPerPage,
              h = n(l),
              f = t(h);
          return k.a.createElement("div", null, c && !!c.options.length && k.a.createElement("div", {
            className: s.sortHolder
          }, k.a.createElement(pn, {
            options: c.options,
            onChange: i
          })), k.a.createElement("div", {
            className: s.elementsHolder
          }, a(h)), k.a.createElement("div", {
            className: s.paginationHolder
          }, k.a.createElement(ln, {
            current: p + 1,
            from: 1,
            to: f,
            onChange: r,
            recordsPerPage: d,
            recordsPerPageOptions: u || [5, 10, 20, 50, 100],
            onChangeRecordsPerPage: o
          })));
        }
      }]), t;
    }(),
        fn = Object(L.withStyles)(j.getStyle("Browser", dn))(hn),
        mn = function mn(e) {
      return function (t) {
        return {
          menu: {
            backgroundColor: "initial"
          },
          icon: {
            fontSize: "1.6em"
          },
          pendingHolder: {
            textAlign: "center",
            paddingTop: "50px"
          },
          stateIcon: {
            fontSize: "3rem",
            marginBottom: "10px"
          },
          default: {
            color: e.palette.default
          },
          danger: {
            color: e.palette.danger
          },
          historyHolder: {
            paddingLeft: "20px"
          },
          historyList: {
            listStyle: "none",
            borderLeft: "4px solid " + e.palette.default,
            paddingLeft: "25px",
            marginTop: "0px",
            paddingBottom: "16px"
          },
          historyElement: {
            backgroundColor: "#fff",
            padding: "8px",
            margin: "0px 0px 16px 0px"
          },
          historyListItemIndicator: {
            position: "absolute",
            height: "10px",
            width: "10px",
            backgroundColor: "#fff",
            margin: "10px 0px 0px -18px",
            borderRadius: "20px 0px 0px 20px",
            "&:before": {
              borderRight: "3px solid #fff",
              borderBottom: "3px solid #fff",
              width: "10px",
              height: "10px",
              margin: "-8px 0px 0px 0px",
              borderRadius: "0px 0px 20px 0px",
              display: "block",
              content: '""'
            },
            "&:after": {
              borderTop: "3px solid #fff",
              borderRight: "3px solid #fff",
              width: "10px",
              height: "10px",
              margin: "0px 0px 0px 0px",
              borderRadius: "0px 20px 0px 0px",
              display: "block",
              content: '""'
            }
          },
          historyListItemCircleHolder: {
            position: "absolute",
            margin: "-16px 0px 0px -29px",
            borderRadius: "40px",
            padding: "4px 0px",
            backgroundColor: e.palette.body
          },
          historyListItemCircle: {
            display: "block",
            borderRadius: "20px",
            width: "16px",
            height: "16px",
            border: "4px solid " + e.palette.primary,
            backgroundColor: e.palette.body
          },
          historyYearFlag: {
            position: "relative",
            left: "-49px",
            padding: "2px 5px",
            display: "inline-block",
            border: "3px dashed " + e.palette.danger,
            backgroundColor: e.palette.body
          },
          historyYearFlagHolder: {
            marginBottom: "16px"
          }
        };
      };
    },
        gn = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).yearFlag = function (e) {
          var t = n.props.classes;
          return k.a.createElement("li", {
            key: "history:yearFlag" + e.value
          }, k.a.createElement("div", {
            className: t.historyYearFlag
          }, k.a.createElement(T.Typography, {
            variant: "body2"
          }, e.value)));
        }, n.defaultListElement = function () {
          return k.a.createElement("p", null, "No listElement provided!");
        }, n;
      }

      return x(t, w["Component"]), h(t, [{
        key: "renderElements",
        value: function value(e, t) {
          var n = e.$type || "listElement",
              r = this.props.classes;

          switch (n) {
            case "yearFlag":
              return k.a.createElement("li", {
                key: "history:yearFlag" + e.year,
                className: r.historyYearFlagHolder
              }, k.a.createElement("div", {
                className: r.historyYearFlag
              }, k.a.createElement(T.Typography, {
                variant: "body2"
              }, e.year)));

            default:
              var a = this.props.listElement || this.defaultListElement;
              return k.a.createElement("li", {
                className: r.historyElement,
                key: "history-" + (e.id || t)
              }, k.a.createElement("div", {
                className: r.historyListItemIndicator
              }, k.a.createElement("div", {
                className: r.historyListItemCircleHolder
              }, k.a.createElement("span", {
                className: r.historyListItemCircle
              }))), k.a.createElement("div", {
                className: r.historyElementPaper
              }, a(e)));
          }
        }
      }, {
        key: "render",
        value: function value() {
          var e = this,
              t = this.props,
              n = t.classes,
              r = t.pending,
              a = t.error,
              o = t.elements;
          return r ? k.a.createElement("div", {
            className: n.pendingHolder
          }, k.a.createElement(T.CircularProgress, null), k.a.createElement(T.Typography, {
            variant: "body2"
          }, "History wird geladen...")) : a ? k.a.createElement("div", {
            className: B()([n.pendingHolder, n.danger])
          }, k.a.createElement(q.FontAwesomeIcon, {
            className: n.stateIcon,
            icon: V.faExclamationTriangle
          }), k.a.createElement(T.Typography, {
            classes: {
              root: n.danger
            },
            variant: "body2"
          }, "Ein Fehler ist aufgetreten.")) : r || o.length ? k.a.createElement("div", {
            className: n.historyHolder
          }, k.a.createElement("ul", {
            className: n.historyList
          }, o.map(function (t, n) {
            return e.renderElements(t, n);
          }))) : k.a.createElement("div", {
            className: B()([n.pendingHolder, n.default])
          }, k.a.createElement(q.FontAwesomeIcon, {
            className: n.stateIcon,
            icon: V.faSearch
          }), k.a.createElement(T.Typography, {
            classes: {
              root: n.default
            },
            variant: "body2"
          }, "Keine Events gefunden."));
        }
      }]), t;
    }(),
        vn = Object(L.withStyles)(j.getStyle("History", mn))(gn),
        yn = function (e) {
      function t() {
        var e, n;
        p(this, t);

        for (var r = arguments.length, a = new Array(r), o = 0; o < r; o++) {
          a[o] = arguments[o];
        }

        return (n = v(this, (e = y(t)).call.apply(e, [this].concat(a)))).state = {
          open: !1
        }, n.handleClickOpen = function () {
          n.setState({
            open: !0
          });
        }, n.handleClose = function () {
          n.setState({
            open: !1
          });
        }, n;
      }

      return x(t, k.a.Component), h(t, [{
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.fullScreen,
              n = e.open,
              r = e.onClose,
              a = e.title,
              o = e.children,
              i = e.actions,
              s = e.maxWidth;
          return k.a.createElement("div", null, k.a.createElement(T.Dialog, {
            fullScreen: t,
            open: n,
            onClose: r,
            maxWidth: s,
            fullWidth: Boolean(s)
          }, k.a.createElement(T.DialogTitle, null, a), k.a.createElement(T.DialogContent, null, o), Boolean(i) && k.a.createElement(T.DialogActions, {
            style: {
              margin: "0px",
              padding: "0px 24px 8px"
            }
          }, i)));
        }
      }]), t;
    }(),
        bn = Object(T.withMobileDialog)()(yn);

    n.d(t, "Authenticator", function () {
      return Ct;
    }), n.d(t, "Block", function () {
      return H;
    }), n.d(t, "Browser", function () {
      return fn;
    }), n.d(t, "ButtonsComponents", function () {
      return a;
    }), n.d(t, "Router", function () {
      return qt;
    }), n.d(t, "Theme", function () {
      return j;
    }), n.d(t, "FormComponents", function () {
      return r;
    }), n.d(t, "Layouter", function () {
      return zt;
    }), n.d(t, "SubAppBar", function () {
      return Yt;
    }), n.d(t, "History", function () {
      return vn;
    }), n.d(t, "Modal", function () {
      return bn;
    });
  }]);
});